function getFocusableElements(container) {
  if(container){
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
}

const onmouseleaveHandeler = (e) => {
  if(e.classList.contains('variant_image_active')) {
    e.classList.remove('variant_image_active');
  }
}

// Cards flagged with .color-swatch-redirect (setting: card_color_swatch_click
// = "Redirect to product page") send color swatch clicks straight to the
// product page with ?variant= preselected instead of swapping the card
// image/price in place.
const matatCardUsesSwatchRedirect = (cardWrapper) =>
  !!(cardWrapper && cardWrapper.classList.contains('color-swatch-redirect'));

// Swatch clicks can reach us twice (e.g. direct input click plus the label's
// forwarded activation), so swallow repeats of the same URL within a moment
// instead of re-triggering navigation.
let matatLastSwatchRedirect = { url: '', at: 0 };
const matatNavigateToVariantUrl = (url) => {
  if (!url) return;
  const now = Date.now();
  if (matatLastSwatchRedirect.url === url && now - matatLastSwatchRedirect.at < 800) return;
  matatLastSwatchRedirect = { url, at: now };
  window.location.href = url;
};

(()=>{
  // let flickityList = document.querySelectorAll('[data-flickity]');

  // for (let i = 0, t = flickityList.length; i < t; i++) {
  //     let flkty = Flickity.data(flickityList[i]);
  //     if (flkty) {
  //       let vimeo_iframe = flkty.selectedElement.querySelector('iframe');

  //       if(vimeo_iframe) {
  //         let player = new Vimeo.Player(vimeo_iframe);
  //         player.on('loaded', (e) => {
  //           player.getPaused().then(function(paused) {
  //             if(paused) {
  //               player.play();
  //             }
  //           });
  //         });
  //       } else {
  //         return false;
  //       }
  //     }
  // }
})();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if(window.innerWidth > 750){
    if(summary.closest('header-menu')){
      summary.closest('details').addEventListener('mouseenter', (event) => {
        const detailsElement = event.currentTarget;
          if (!detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.setAttribute('open', 'true');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'true');
          }
        
      });
      
      summary.closest('details').addEventListener('mouseleave', (event) => {
        const detailsElement = event.currentTarget;
          if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.removeAttribute('open');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'false');
          }
      });
    }
  }
  
  summary.addEventListener('click', (event) => {
    
    if (summary.classList.contains('matat_filters__summary')) {
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".matat-filter-body details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }

      const sliderWrapper = document.getElementById('matat-range-slider');
        if (sliderWrapper.rangeable) {
          sliderWrapper.rangeable.destroy?.(); // Optional chaining
          sliderWrapper.style.display = 'none';
          sliderWrapper.offsetHeight; // force reflow
          sliderWrapper.style.display = '';
          MatatFiltersForm.priceRangeSlider(); // re-init
        }
      
      }
      if(summary.closest('.product__accordion')){ 
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".product__accordion details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }
      }
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  // Looked up on each use: the container's content can change while it is open (e.g. wishlist
  // items added/removed), and hidden (display: none) elements can never be first/last.
  const getEdges = () => {
    const elements = getFocusableElements(container).filter((el) => el.getClientRects().length > 0);
    return { first: elements[0], last: elements[elements.length - 1] };
  };

  trapFocusHandlers.focusin = (event) => {
    const { first, last } = getEdges();
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    const { first, last } = getEdges();
    if (!first) return;
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  // document.querySelectorAll('.js-youtube').forEach((video) => {
  //   video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  // });
  // document.querySelectorAll('.js-vimeo').forEach((video) => {
  //   video.contentWindow.postMessage('{"method":"pause"}', '*');
  // });
  // document.querySelectorAll('video').forEach((video) => video.pause());
  // document.querySelectorAll('product-model').forEach((model) => {
  //   if (model.modelViewerUI) model.modelViewerUI.pause();
  // });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

// The gallery slides to show for a color: the slides whose data-media-alt is
// that color, then the ones with an empty data-media-alt - photos whose alt
// names no color, such as group shots (see media-alt-color.liquid) - so those
// stay visible with every color. When no slide has the color, all are shown.
function matatSlidesForColor(slides, color) {
  const target = (color || '').toString().trim().toLowerCase();
  const altOf = (slide) => (slide.getAttribute('data-media-alt') || '').trim().toLowerCase();
  const matched = slides.filter((slide) => altOf(slide) === target);
  if (!matched.length) return slides;
  return matched.concat(slides.filter((slide) => altOf(slide) === ''));
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));

      setTimeout(() => {

        // Work only inside the modal this button opened. On a product page the
        // page's own gallery and the quick views of related product cards are
        // all in the document; searching the whole page rebuilt the page's
        // gallery with the other product's photos.
        if (!modal) return;

        const selectedInputColor = modal.querySelector('.variation-color-wrapper .color_label input:checked');

        if (selectedInputColor) {

          const selectedColor = selectedInputColor.value.trim();

          // Set currentVariant with option1

          this.currentVariant = { option2: selectedColor };

          // Call the method with color value (optional argument)

          this.slideToSelectedVariant(selectedColor, modal);

        } else {

          const quickModel = modal;

          const mainWrapperModel = modal.querySelector(
            '.product__media-list .swiper-wrapper'
          );

          if (!mainWrapperModel) return;

          mainWrapperModel.innerHTML = '';

          modal.querySelectorAll('#all-product-slides .product__media-item')
            .forEach(slide => {
              const clone = slide.cloneNode(true);
              clone.classList.add('swiper-slide');
              mainWrapperModel.appendChild(clone);
            });

          const galleryEl = quickModel.querySelector('.main-product-thumbanila-slider');
          const isSideLayout = galleryEl?.closest('.main_slider_side');

          let mainSwiper, thumbSwiper;

          if (isSideLayout) {
            const thumbWrapper = quickModel.querySelector(
              '.thumbnail_slider_side .swiper-wrapper'
            );

            if (thumbWrapper) {
              thumbWrapper.innerHTML = '';

              modal.querySelectorAll('#all-product-slides .thumbnail-list__item')
                .forEach(slide => {
                  const clone = slide.cloneNode(true);
                  clone.classList.add('swiper-slide');
                  thumbWrapper.appendChild(clone);
                });
            }

            thumbSwiper = new Swiper('.thumbnail_slider_side', {
              spaceBetween: 15,
              slidesPerView: 4,
              watchSlidesProgress: true,
              direction: 'vertical',
              rtl: true,
            });

            mainSwiper = new Swiper('.product-slider-gallery', {
              spaceBetween: 0,
              rtl: true,
              thumbs: { swiper: thumbSwiper },

              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });

            mainSwiper.slideTo(0);
            thumbSwiper.slideTo(0);

          } else {
            mainSwiper = new Swiper('.product-slider-gallery', {
              spaceBetween: 0,
              rtl: true,
            });
          }
          window.mainSwiper = mainSwiper;
          window.thumbSwiper = thumbSwiper;
        }
      }, 1500); // wait for Shopify to hydrate

      if (modal) modal.show(button);
    });
  }
  
  slideToSelectedVariant(color, root = document) {
    if (!color) return;

    const mainWrapper = root.querySelector('.product__media-list .swiper-wrapper');
    if (!mainWrapper) return;

    mainWrapper.innerHTML = ''; // Clear old slides
    const allSlides = [...root.querySelectorAll('#all-product-slides .product__media-item')];

    matatSlidesForColor(allSlides, color).forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('swiper-slide');
      mainWrapper.appendChild(clone);
    });
    // Optional: Reinitialize Swiper if needed
    if (window.mainSwiper) {
      window.mainSwiper.update(); // or destroy + init
    }

  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    this.loadContent();
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    // if (!this.getAttribute('loaded')) {
    //   const content = document.createElement('div');
    //   content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

    //   this.setAttribute('loaded', true);
    //   const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
    //   if (focus) deferredElement.focus();
    //   if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
    //     // force autoplay for safari
    //     deferredElement.play();
    //   }
    // }
  }
}

customElements.define('deferred-media', DeferredMedia);

document.body.addEventListener('click', function (e) {
    let target = e.target;
    // if(target.classList.contains('custom_variation_button')) {
    //   let find_quick_btn = target.closest('.product-card-wrapper').querySelector("modal-opener");
    //   if(find_quick_btn){
    //     let updated_url = target.closest("label").getAttribute("data-variant-url");
    //     find_quick_btn.querySelector("button").setAttribute('data-product-url', updated_url);
    //   }
    //   let parentItem = target.closest('.product-card-wrapper').querySelector('.product-card_inline-variation').querySelector('.product-form__input.listen_color_change');
    //   let actual_var_item = parentItem.querySelector('[value="'+target.value+'"]');
    //       actual_var_item.checked = true;
    //       parentItem.dispatchEvent(new CustomEvent('color_change',{'detail': target.value}));
    //       actual_var_item.dispatchEvent(new Event('custom_change'));
    //       // let variant_radios = target.closest('.product-card-wrapper').querySelector('variant-radios');
    //       // variant_radios.dispatchEvent(new Event('change'));
    // }

    if (target.classList.contains("custom_variation_button")) {

      const wrapper = target.closest(".product-card-wrapper");

      if (!wrapper) return;

      // Redirect mode: open the product page with the clicked color
      // preselected (?variant=) instead of updating the card in place.
      if (matatCardUsesSwatchRedirect(wrapper)) {
        const redirectUrl = target.closest("label")?.getAttribute("data-variant-url");
        matatNavigateToVariantUrl(redirectUrl);
        return;
      }

      const quickBtn = wrapper.querySelector("modal-opener");

      if (quickBtn) {

        const updated_url = target.closest("label")?.getAttribute("data-variant-url");

        if (updated_url) {

          quickBtn.querySelector("button")?.setAttribute("data-product-url", updated_url);

        }

      }


      const parentItem = wrapper.querySelector(".product-card_inline-variation .product-form__input.listen_color_change");

      if (!parentItem) return;



      const actualVarItem = parentItem.querySelector(`[value="${target.value}"]`);

      if (!actualVarItem) return;



      actualVarItem.checked = true;

      parentItem.dispatchEvent(new CustomEvent("color_change", { detail: target.value }));

      actualVarItem.dispatchEvent(new Event("custom_change", { bubbles: true }));

    }
    if(target.closest('variant-radios') && target.closest('.product-card-wrapper')) {
      if(target.tagName.toUpperCase() == 'INPUT') {
        target.closest('variant-radios').dispatchEvent(new Event('change'));
      }
    }
});

// Safety net for redirect mode on surfaces where the click never lands on the
// hidden radio itself (search results grid, predictive search modal): react to
// clicks anywhere inside a swatch label - or on a meta color anchor - of a
// redirect-mode card and go straight to the product page.
document.body.addEventListener('click', function (e) {
  const cardWrapper = e.target.closest?.('.color-swatch-redirect.product-card-wrapper');
  if (!cardWrapper) return;

  const swatchLabel = e.target.closest('label[data-variant-url]');
  if (swatchLabel && cardWrapper.contains(swatchLabel)) {
    e.preventDefault();
    matatNavigateToVariantUrl(swatchLabel.getAttribute('data-variant-url'));
    return;
  }

  const metaSwatch = e.target.closest('a.variation-color[data-color-url]');
  if (metaSwatch && cardWrapper.contains(metaSwatch)) {
    e.preventDefault();
    matatNavigateToVariantUrl(metaSwatch.getAttribute('data-color-url') || metaSwatch.getAttribute('href'));
  }
});
/*
  Product card image slider behaviour that the Flickity options cannot express,
  because every init passes a `responsive` array that plain Flickity ignores:

  - Dots: never show more than MAX_DOTS at once. A card with more images than
    that keeps the row a fixed width and slides the visible window along with
    the selected slide, so the active dot is always in view. The dot sitting on
    an edge that still has hidden dots behind it is shrunk, which is what
    signals there is more to come.
  - Swipe: dragging is enabled below the mobile breakpoint only, where the
    arrows are hidden, and switched off again above it so it cannot interfere
    with the card's hover image swap.

  Exposed on window because MatatCardImageSlider, just below, hands every
  slider it builds straight here - that gate is now the single place a card
  image slider is created, whichever file asked for it (global.js,
  matat-filter.js, matat-filter-search.js, predictive-search.js,
  main-collection-product-grid.liquid, related-products.liquid,
  infinite-scrolling.liquid).
*/
window.MatatCardSlider = (function () {
  const MAX_DOTS = 3;
  const MOBILE_QUERY = '(max-width: 749px)';
  // Enough travel that a vertical flick down the product grid is never read as
  // a swipe. `touch-action: pan-y`, which Flickity sets on a draggable slider,
  // keeps the page itself scrolling normally.
  const DRAG_THRESHOLD = 12;

  function render(slider) {
    const flkty = window.Flickity && Flickity.data(slider);
    const list = slider.querySelector('.flickity-page-dots');
    if (!flkty || !list) return;

    const dots = Array.from(list.children);
    if (dots.length <= MAX_DOTS) {
      dots.forEach((dot) => dot.classList.remove('dot-out-of-window', 'dot-edge'));
      return;
    }

    // Window of MAX_DOTS that keeps the selected dot roughly centred and stops
    // sliding once either end of the strip is reached.
    const start = Math.min(
      Math.max(flkty.selectedIndex - Math.floor(MAX_DOTS / 2), 0),
      dots.length - MAX_DOTS
    );
    const end = start + MAX_DOTS - 1;

    dots.forEach((dot, index) => {
      const visible = index >= start && index <= end;
      dot.classList.toggle('dot-out-of-window', !visible);
      dot.classList.toggle(
        'dot-edge',
        visible && ((index === start && start > 0) || (index === end && end < dots.length - 1))
      );
    });
  }

  // Flickity reads options.draggable / options.dragThreshold live, so the
  // slider can be made swipeable without being rebuilt.
  function syncDraggable(flkty) {
    const draggable = window.matchMedia(MOBILE_QUERY).matches;
    flkty.options.dragThreshold = DRAG_THRESHOLD;
    if (flkty.options.draggable === draggable) return;
    flkty.options.draggable = draggable;
    flkty.updateDraggable();
  }

  function bind(slider) {
    const flkty = window.Flickity && Flickity.data(slider);
    if (!flkty) return;
    syncDraggable(flkty);
    if (!flkty.matatCardSliderBound) {
      flkty.matatCardSliderBound = true;
      flkty.on('change', () => render(slider));
    }
    render(slider);
  }

  // Runs on every resize so drag follows the breakpoint, and because
  // FlickityResponsive swaps the instance when it crosses its own breakpoint,
  // which rebuilds the dots and drops the change handler.
  window.addEventListener(
    'resize',
    debounce(() => {
      document.querySelectorAll('.flikity_grid_image').forEach(bind);
    }, 200)
  );

  return { attach: bind };
})();

/*
  MatatCardImageSlider - the breakpoint gate every card image slider goes
  through.

  settings.enable_image_slider_desktop and settings.enable_image_slider_mobile
  are independent, so a card can carry a slider on one side of the 750px
  breakpoint and a plain image on the other. card-product.liquid renders the
  slider markup whenever either is on and stamps the pair onto the slider as
  data-slider-desktop / data-slider-mobile; this module reads those and decides,
  for the current width, whether a Flickity instance should exist at all.
  Crossing the breakpoint builds or destroys it, so the merchant's choice holds
  through a resize or an orientation change. With no instance the cells are
  plain divs again and component-card.css hides all but the first, which is also
  what the page paints before this runs.

  Options differ per call site (the collection grid wants arrows, predictive
  search does not, infinite scroll builds through FlickityResponsive), so each
  slider is registered with the options and constructor its own caller chose and
  is rebuilt with exactly those. Callers replaced their `new Flickity(...)` with
  `MatatCardImageSlider.setup(slider, options)` and no longer need to call
  MatatCardSlider.attach - that happens here.
*/
window.MatatCardImageSlider = (function () {
  const MOBILE_QUERY = '(max-width: 749px)';
  const registry = new Map();

  function enabledHere(slider) {
    const flag = window.matchMedia(MOBILE_QUERY).matches
      ? slider.dataset.sliderMobile
      : slider.dataset.sliderDesktop;
    // A slider rendered without the attributes predates the desktop/mobile
    // split (or comes from markup this module does not own) - leave it live.
    return flag === undefined ? true : flag === 'true';
  }

  function apply(slider, options, Ctor) {
    const existing = window.Flickity && Flickity.data(slider);
    if (!enabledHere(slider)) {
      if (existing) existing.destroy();
      return;
    }
    if (existing) {
      if (window.MatatCardSlider) MatatCardSlider.attach(slider);
      return;
    }
    new Ctor(slider, options);
    const created = Flickity.data(slider);
    // Built as the breakpoint flips, where CSS had the slider display:none a
    // moment earlier - measure again once it is laid out or it keeps a
    // zero-height viewport.
    if (created) requestAnimationFrame(function () { created.resize(); });
    if (window.MatatCardSlider) MatatCardSlider.attach(slider);
  }

  // `Ctor` defaults to Flickity; infinite-scrolling.liquid passes
  // FlickityResponsive, which reads the `responsive` option and swaps the
  // instance at its own breakpoints. Both register under Flickity.data, so the
  // create/destroy bookkeeping above is the same for either.
  function setup(slider, options, Ctor) {
    if (!slider || !window.Flickity) return;
    const constructor = Ctor || window.Flickity;
    registry.set(slider, { options: options, Ctor: constructor });
    apply(slider, options, constructor);
  }

  function setupAll(sliders, options, Ctor) {
    if (!sliders) return;
    Array.prototype.forEach.call(sliders, function (slider) {
      setup(slider, options, Ctor);
    });
  }

  function refresh() {
    registry.forEach(function (entry, slider) {
      // Filtering and infinite scroll replace whole grids; a slider that left
      // the document keeps nothing alive here.
      if (!slider.isConnected) {
        registry.delete(slider);
        return;
      }
      apply(slider, entry.options, entry.Ctor);
    });
  }

  // A media-query listener fires exactly on the 750px crossing, so the
  // instances flip in step with the CSS that hides the extra cells instead of
  // a debounce behind it. The debounced resize stays as a safety net for
  // browsers that give us no change event.
  const mql = window.matchMedia(MOBILE_QUERY);
  if (mql.addEventListener) {
    mql.addEventListener('change', refresh);
  } else if (mql.addListener) {
    mql.addListener(refresh);
  } else {
    window.addEventListener('resize', debounce(refresh, 200));
  }

  return { setup: setup, setupAll: setupAll, refresh: refresh };
})();

document.addEventListener("DOMContentLoaded", (event) => {
  // pageDots stays on so the dot markup exists for the mobile layout -
  // component-card.css hides it below 750px and shows it above.
  // `responsive` is only read by FlickityResponsive, not by Flickity.
  // MatatCardImageSlider decides per slider whether this width is one the card
  // opted into, and attaches MatatCardSlider for the ones it builds.
  MatatCardImageSlider.setupAll(document.querySelectorAll('.flikity_grid_image'), {
    "imagesLoaded": true,
    "rightToLeft": true,
    "cellAlign": "right",
    "pageDots": true,
    "wrapAround": true,
    "draggable": false,
    "responsive": [
      {
        "breakpoint": 750,
        "settings": {
          "freeScroll": true,
          "wrapAround": false,
          "contain": true,
          "prevNextButtons": false,
          "draggable": false,
          "pageDots": true
        }
      }
    ]
  });
  // if(document.querySelector(".product__media-list.Product_main_slider")){
  //     var carousel_main = document.querySelectorAll('.product__media-list.Product_main_slider');
  //     carousel_main.forEach((slide) => {
  //         flkty = new Flickity(slide, {
  //         "imagesLoaded": true,
  //         "rightToLeft":true,
  //         "cellAlign":"right",
  //         "pageDots": true,
  //         "prevNextButtons": true,
  //         "wrapAround": true
  //       });
  //     })
  //   }
  });

let mobileSwiper = null;
function initMobileSwiper() {
  const wrapper = document.querySelector('.product__media-wrapper');
  // Only proceed if .product__media-wrapper exists in the DOM
  if (!wrapper) return;
  if (window.innerWidth <= 749 && mobileSwiper === null) {
    mobileSwiper = new Swiper('.product__media-list', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: false,
      rtl: true,
      navigation: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  } else if (window.innerWidth > 749 && mobileSwiper !== null) {
    mobileSwiper.destroy(true, true);
    mobileSwiper = null;
  }
}

// Run on load
initMobileSwiper();

// Optional: Run on resize
window.addEventListener('resize', () => {
  initMobileSwiper();
});

function initProductGallery() {
  const productWrapper = document.querySelector('.single_main_product_wrapper');
  if (!productWrapper) return;

  // 🔍 Check specifically for COLOR variant — those are handled by slideToSelectedVariant
  const hasColorVariant = productWrapper.querySelector(
    'fieldset.js.product-form__input.single_product_variant.variation-color-wrapper'
  );
  if (hasColorVariant) return;

  const removGiftcard = productWrapper.querySelector('.product--giftcard');

  const mainWrapper = productWrapper.querySelector(
    '.product__media-list .swiper-wrapper'
  );

  if (!mainWrapper) return;

  mainWrapper.innerHTML = '';

  document.querySelectorAll('#all-product-slides .product__media-item')
    .forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('swiper-slide');
      mainWrapper.appendChild(clone);
    });

  const galleryEl = productWrapper.querySelector('.main-product-thumbanila-slider');
  const isSideLayout = galleryEl?.closest('.main_slider_side');

  let mainSwiper, thumbSwiper;

  if (isSideLayout) {
    const thumbWrapper = productWrapper.querySelector(
      '.thumbnail_slider_side .swiper-wrapper'
    );

    if (thumbWrapper) {
      thumbWrapper.innerHTML = '';

      document.querySelectorAll('#all-product-slides .thumbnail-list__item')
        .forEach(slide => {
          const clone = slide.cloneNode(true);
          clone.classList.add('swiper-slide');
          thumbWrapper.appendChild(clone);
        });
    }

    thumbSwiper = new Swiper('.thumbnail_slider_side', {
      spaceBetween: 15,
      slidesPerView: 4,
      watchSlidesProgress: true,
      direction: 'vertical',
      rtl: true,
    });

     if(!removGiftcard) {
    mainSwiper = new Swiper('.product-slider-gallery', {
      spaceBetween: 0,
      rtl: true,
      thumbs: { swiper: thumbSwiper },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    mainSwiper.slideTo(0);
    thumbSwiper.slideTo(0);
  } else {
    mainSwiper = new Swiper('.product-slider-gallery', {
      spaceBetween: 0,
      rtl: true
    });

    mainSwiper.slideTo(0);
  }

  } else {
    mainSwiper = new Swiper('.product-slider-gallery', {
      spaceBetween: 0,
      rtl: true,
    });
  }

  window.mainSwiper = mainSwiper;
  window.thumbSwiper = thumbSwiper;
}
window.initProductGallery = initProductGallery;
initProductGallery();

// ============================================================
// PRODUCT PAGE — SCROLL BACK TO TOP ON VARIANT CHANGE
// Called from: VariantSelects.onVariantChange  (regular variant pickers)
//              meta color swatch handler       (add_products_for_color_options)
//
// Both flows update the product in place, so once the shopper has scrolled
// past the gallery, the new image/product would never be seen. Runs on every
// viewport, desktop included. Scoped to the real product page sections
// (.single_main_product_wrapper) so product cards and the quick-add modal
// are left alone.
//
// Call this AFTER the gallery has been rebuilt. slideToSelectedVariant()
// empties .swiper-wrapper and destroys/re-inits Swiper, so mid-rebuild the
// document height collapses; the browser then clamps the scroll offset, which
// kills scrollTo({behavior:'smooth'}) and reads as an instant jump. Hence the
// double rAF (animate over a settled layout) and the hand-rolled easing below
// — it steps from wherever the page actually is each frame, so a late clamp
// can only speed the animation up, never bounce it back down.
// ============================================================

function matatScrollProductTop(el) {
  if (!el) return;
  if (el.closest('quick-add-modal') || el.closest('.product-card-wrapper')) return;
  if (!el.closest('.single_main_product_wrapper')) return;

  requestAnimationFrame(function () {
    requestAnimationFrame(matatSmoothScrollTop);
  });
}
window.matatScrollProductTop = matatScrollProductTop;

function matatSmoothScrollTop() {
  if (window._matatScrollingTop) return;

  var y = window.pageYOffset || document.documentElement.scrollTop || 0;
  if (y <= 0) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, 0);
    return;
  }

  window._matatScrollingTop = true;

  function finish() {
    window._matatScrollingTop = false;
    window.removeEventListener('touchstart', finish);
    window.removeEventListener('wheel', finish);
  }

  // Hand control straight back if the shopper starts scrolling themselves.
  window.addEventListener('touchstart', finish, { passive: true });
  window.addEventListener('wheel', finish, { passive: true });

  function step() {
    if (!window._matatScrollingTop) return;

    var current = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (current <= 1) {
      window.scrollTo(0, 0);
      finish();
      return;
    }

    window.scrollTo(0, Math.floor(current * 0.8) - 1);
    requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}
window.matatSmoothScrollTop = matatSmoothScrollTop;

// ============================================================
// PRODUCT PAGE — ACTIVATE THE DEEP-LINKED ?variant= COLOR
// Card color swatches in "Redirect to product page" mode land on the
// product page with ?variant=<id>. The server preselects that variant,
// but a fallback (e.g. sold-out first match) can leave a different
// color active. Re-sync every picker inside the main product wrapper
// from the URL so the clicked color is always active on arrival.
// Scoped to .single_main_product_wrapper so product cards and the
// quick-add modal are left alone.
// ============================================================

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    try {
      var params = new URLSearchParams(window.location.search);
      var variantId = parseInt(params.get('variant'), 10);
      if (!variantId) return;

      var wrappers = document.querySelectorAll('.single_main_product_wrapper');
      if (!wrappers.length) return;

      var escapeAttr = function (val) {
        return String(val).trim().replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      };

      wrappers.forEach(function (wrapper) {
        wrapper.querySelectorAll('variant-radios').forEach(function (radios) {
          var dataScript = radios.querySelector('script[type="application/json"]');
          if (!dataScript) return;

          var variants;
          try { variants = JSON.parse(dataScript.textContent); } catch (err) { return; }
          if (!Array.isArray(variants)) return;

          var linkedVariant = variants.find(function (v) { return Number(v.id) === variantId; });
          if (!linkedVariant) return;

          var optionValues = linkedVariant.options && linkedVariant.options.length
            ? linkedVariant.options
            : [linkedVariant.option1, linkedVariant.option2, linkedVariant.option3];

          var fieldsets = radios.querySelectorAll('fieldset.product-form__input');
          var changed = false;
          var changedColorInput = null;

          fieldsets.forEach(function (fieldset, index) {
            var value = optionValues[index];
            if (!value) return;
            var input = fieldset.querySelector(
              'input[type="radio"][value="' + escapeAttr(value) + '"]'
            );
            if (input && !input.checked) {
              input.checked = true;
              changed = true;
              if (fieldset.classList.contains('variation-color-wrapper')) {
                changedColorInput = input;
              }
            }
          });

          // Re-run the normal change flow (legend, price, gallery slide,
          // buy button) only when something actually moved.
          if (changed) {
            var target =
              changedColorInput ||
              (fieldsets[0] && fieldsets[0].querySelector('input[type="radio"]:checked'));
            if (target) target.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    } catch (err) {}
  }, 200);
});

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    if(this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
      if(this.querySelector('.product-form__input.listen_color_change') && this.querySelector('.product-form__input.image_switcher_activated')){
        this.querySelector('.product-form__input.listen_color_change').addEventListener('color_change', (e) => {
          
          const variant_image = this.updateSingleMedia(e.detail);
          // if(e.target.closest(".card__inner").querySelector(".card__media").classList.contains("enable_image_slider")){
          //   if(variant_image){
          //      var taeget_index = e.target.closest(".card__inner").querySelector(".card__media").querySelector(`img[src="${variant_image}&width=460"]`).closest('.pro-media').dataset.index;
          //      var flkty = Flickity.data(e.target.closest(".card__inner").querySelector(".card__media .flikity_grid_image"));
          //      if(flkty){
          //       flkty.select(taeget_index)  
          //      }
          //   }
          // }else{
          //   if(variant_image){
          //     this.closest('.product-card-wrapper').querySelector('img.variant_image_element').srcset = variant_image;
          //     this.closest('.product-card-wrapper').querySelector('img.variant_image_element').src = variant_image;
          //   }
          //   this.closest('.product-card-wrapper').classList.add('variant_image_active');
          // }
          // on home page product sider on color change the color of quick view

          let $selected_colors = e.target.querySelector("input:checked").value;
          let get_current_var_id = e.target.closest(".product-card-wrapper").querySelector(".quick-add__submit").getAttribute("data-variant-id");
          if(document.querySelector(`quick-add-modal[data-variant-id='${get_current_var_id}']`)){
            let current_quick_add = document.querySelector(`quick-add-modal[data-variant-id='${get_current_var_id}']`);
            current_quick_add.setAttribute("data-selected_vartitle",$selected_colors);
          }
          

          // code ends here
          const cardWrapper = this.closest('.product-card-wrapper');
          const cardInner = e.target.closest(".card__inner");

          if (cardInner) {
            const mediaWrapper = cardInner.querySelector(".card__media");
            if (mediaWrapper && mediaWrapper.classList.contains("enable_image_slider")) {
              rebuildCarouselForColor(cardWrapper, e.detail);
            } else if (variant_image) {
              const img = cardWrapper.querySelector("img.variant_image_element");
              if (img) {
                img.src = variant_image;
                img.srcset = variant_image;
              }
              cardWrapper.classList.add("variant_image_active");
            }
          }

          updateStandardCardSoldOut(cardWrapper, e.detail);
          
          // Tooltip color change event
          const card = this.closest(".card-wrapper");
          if (card) {
            card.querySelectorAll(".card__content .card-mobile-quickview")
              .forEach(el => el.classList.remove("select_color"));
          }

          // Updating Variant Button
          const variant_details = this.getVariantDetails(e.detail);
          const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
          var $this = this;
          $variant_input.forEach(function(input){
            input.classList.remove('select_color');
            var this_value = input.getAttribute('value');
            switch(input.getAttribute('data-option')) {
              case "1":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option1 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "2":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option2 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "3":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option3 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              default:
            }
          });
        });
      }
    }
    // if(this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
    //   if(this.querySelector('.product-form__input.listen_color_change') && this.querySelector('.product-form__input.image_switcher_activated')){
    //     this.querySelector('.product-form__input.listen_color_change').addEventListener('color_change', (e) => {
    //       const variant_image = this.updateSingleMedia(e.detail);
    //       if(e.target.closest(".card__inner").querySelector(".card__media").classList.contains("enable_image_slider")){
    //         if(variant_image){
    //            var taeget_index = e.target.closest(".card__inner").querySelector(".card__media").querySelector(`img[src="${variant_image}&width=460"]`).closest('.pro-media').dataset.index;
    //            var flkty = Flickity.data(e.target.closest(".card__inner").querySelector(".card__media .flickity_grid"));
    //            if(flkty){
    //             flkty.select(taeget_index)  
    //            }
    //         }
    //       }else{
    //         if(variant_image){
    //           this.closest('.product-card-wrapper').querySelector('img.variant_image_element').srcset = variant_image;
    //           this.closest('.product-card-wrapper').querySelector('img.variant_image_element').src = variant_image;
    //         }
    //         this.closest('.product-card-wrapper').classList.add('variant_image_active');
    //       }


    //       // Updating Variant Button
    //       const variant_details = this.getVariantDetails(e.detail);
    //       const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
    //       var $this = this;
    //       $variant_input.forEach(function(input){
    //         input.classList.remove('select_color');
    //         var this_value = input.getAttribute('value');
    //         switch(input.getAttribute('data-option')) {
    //           case "1":
    //             var condition = variant_details.find((x)=>{
    //                 return x.available && x.option1 == this_value
    //             });
    //             $this.updateVariantButton(condition, input)
    //             break;
    //           case "2":
    //             var condition = variant_details.find((x)=>{
    //                 return x.available && x.option2 == this_value
    //             });
    //             $this.updateVariantButton(condition, input)
    //             break;
    //           case "3":
    //             var condition = variant_details.find((x)=>{
    //                 return x.available && x.option3 == this_value
    //             });
    //             $this.updateVariantButton(condition, input)
    //             break;
    //           default:
    //         }
    //       });
    //     });
    //   }
    // }
    if(this.querySelector(".custom-select")){
      this.querySelectorAll(".custom-select .custom-selected").forEach((select_opt) => {
        select_opt.addEventListener("click", (e) => {
            e.target.nextElementSibling.classList.toggle("active");
        })
      })

      this.querySelectorAll(".custom-select .custom-select-options div").forEach((opt) => {
        opt.addEventListener("click", (optval) => {
          this.querySelectorAll(".custom-select .custom-select-options div").forEach((optremove) => {
            optremove.classList.remove("selected_val");
          });
          let $optvalue = optval.target.innerHTML;
          optval.target.closest(".custom-select").querySelector(".custom-selected span").innerHTML = $optvalue;
          optval.target.closest(".custom-select-options").classList.remove("active");
          optval.target.classList.add("selected_val");
          // change real select option
          let $s = optval.target.closest(".product-form__input--dropdown").getElementsByTagName("select")[0];
          let $sl = $s.length;
          for (let i = 0; i < $sl; i++) {
            if ($s.options[i].innerHTML == $optvalue) {
              $s.options[i].selected = true;
              $s.dispatchEvent(new Event("change", { bubbles: true }));
              break;
            }
          }
        })    
      })
    }

    this.mainSwiper = null;

    // Wait until DOM + variant is ready

    document.addEventListener('DOMContentLoaded', () => {

      setTimeout(() => {

        const selectedColorInput = document.querySelector('.variation-color-wrapper .color_label input:checked');

        if (selectedColorInput) {

          const selectedColor = selectedColorInput.value.trim();
          // Set currentVariant with option1

          this.currentVariant = { option1: selectedColor };

          // Call the method with color value (optional argument)

          this.slideToSelectedVariant(selectedColor);

        } else {

          

        }

      }, 100); // wait for Shopify to hydrate

    });

  }

  updateVariantButton(condition, input){
    if(condition){
      input.classList.remove('disabled')
    }else{
      input.classList.add('disabled')
    }
  }

  onVariantChange(e) {
    const fieldset = e.target.querySelectorAll('fieldset');
    let checked_count = 0;
    fieldset.forEach((item)=>{
      if(item.querySelectorAll('input[type="radio"]:checked').length > 0) {
        checked_count++;
      }
    })
    if(checked_count < fieldset.length ) return;
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateVariantInput();
          this.renderProductInfo();
        }
        this.quickAddToCart();
    } else {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      
      if(e.target.closest('.product-form__input').classList.contains('variation-color-wrapper')) {
        // this.updateMedia(e.target.value);
        // A picker inside a quick view: quick-add.js filters the quick view's
        // own gallery (quickViewSlideToColor). slideToSelectedVariant rebuilds
        // the page's gallery, so on a product page it would show the quick
        // view product's photos there.
        if (!this.closest('quick-add-modal')) this.slideToSelectedVariant(e.target.value);

      }

      // Ease the page back up so the gallery is visible again. After
      // slideToSelectedVariant, so the animation runs over the rebuilt gallery.
      matatScrollProductTop(this);

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  quickAddToCart() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      let enabledCounter = 0;
      const variant_form = this.querySelector('product-form').querySelector('form');

    inputWrappers.forEach((option, index) => {
      const selectedOptionInput = option.querySelector(':checked');
      if(selectedOptionInput && !selectedOptionInput.classList.contains('disabled')) {
        enabledCounter++;
        if(enabledCounter == inputWrappers.length) {
          variant_form.dispatchEvent(new Event('submit'))
          this.closest('.product-card-wrapper').querySelector('.quick_add_loading').classList.remove('hidden')
          this.closest('.product-card-wrapper').classList.add('adding_cart')
        }
      }
      // const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      // const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      // this.setInputAvailability(optionInputs, availableOptionInputsValue)

      // if(product_card && option.classList.contains('visually-hidden')) {
      //   product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
      //   const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
      //   this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
      // }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia(color) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);

    // this.getVariantData().find((variant) => {
    //   return !variant.options.map((option, index) => {
    //     return this.options[index] === option;
    //   }).includes(false);
    // });

    var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
    let main_images = [],
        thumb_images = [];

    for (let img_src of variant_images) {
      const main_classes = ['product__media-item', 'grid__item', 'slider__slide']
      let main_img = document.createElement("li");
      main_img.classList.add(...main_classes);
      main_img.innerHTML = `<a href="${img_src}" data-pswp-width="1000" data-pswp-height="1500">
                    <div class="product-media-container media-type-image media-fit-contain gradient" style="--ratio: 0.6666666666666666; --preview-ratio: 0.6666666666666666;">
                    <div class="product__media media media--transparent has_zoom_element">
                          <img src="${img_src}&amp;width=1946" alt="">
                        </div>
                    </div>
                  </a>`;
      main_images.push(main_img);

      const thumb_classes = ['thumbnail-list__item', 'slider__slide']
      let thumb_img = document.createElement("li");
      thumb_img.classList.add(...thumb_classes);
      thumb_img.innerHTML = `<button class="thumbnail global-media-settings global-media-settings--no-shadow"><img src="${img_src}&amp;width=416" alt=""></button>`;
      thumb_images.push(thumb_img);
    }

    const main_product_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.product__media-list[data-flickity]'));
    const main_old_cells = main_product_gallery.cells.map(cell => cell.element);
    if(main_old_cells.length) {
      main_product_gallery.remove(main_old_cells);
    }
    main_product_gallery.insert( main_images, 0 );
    main_product_gallery.select(0);

    const thumb_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.thumbnail_slider_side[data-flickity]'));
    const thumb_old_cells = thumb_gallery.cells.map(cell => cell.element);
    if(thumb_old_cells.length) {
      thumb_gallery.remove(thumb_old_cells);
    }
    setTimeout(() =>{
      if(thumb_images.length>4) {
        thumb_gallery.insert( thumb_images, 0 );
      } else {
        let flktyOptions = JSON.parse(thumb_gallery.element.dataset.flickity);
        delete flktyOptions.wrapAround;
        flktyOptions.contain = true;
        thumb_gallery.insert( thumb_images, 0 );

        setTimeout(() =>{
          thumb_gallery.destroy();
          let new_flickity = new Flickity(thumb_gallery.element, flktyOptions);
          new_flickity.reposition();
        },50);
      }
    },20);
  }

  // slideToSelectedVariant(color){
  //   // console.log("working slideToSelectedVariant", color)
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;
  //   // console.log("this", this, this.currentVariant.featured_media.id)
  //   var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];    
  //   var target_image = variant_images[0];
  //   var taeget_index = document.querySelector(`.slider__slide a[href="${target_image}"]`).closest('.product__media-item').dataset.index || null;    
  //   var flkty = Flickity.data(document.querySelector('.product-slider-gallery.Product_main_slider'));
  //   if(flkty){
  //     // console.log("flkty", flkty , taeget_index)
  //     flkty.select(taeget_index)  
  //   }
  //   return;
  // }


    // New version – supports color in any option position, handles ALL desktop layouts
slideToSelectedVariant() {
  if (!this.currentVariant) return;
  if (!document.querySelector('.product__media-wrapper') || typeof Swiper === 'undefined') return;

  // ── 1. Detect selected color ───────────────────────────────────────────────
  let variantColor = null;

  const allFieldsets = [...this.querySelectorAll('.product-form__input')];
  const colorFieldsetIndex = allFieldsets.findIndex(fs =>
    fs.classList.contains('variation-color-wrapper')
  );

  if (colorFieldsetIndex !== -1) {
    // option1, option2, option3 correspond to index 0, 1, 2
    const optionKey = `option${colorFieldsetIndex + 1}`;
    const val = this.currentVariant[optionKey];
    if (val) variantColor = val.toLowerCase();
  }

  // Fallback: try option1 then option2 if no color fieldset detected
  if (!variantColor) {
    if (this.currentVariant.option1) variantColor = this.currentVariant.option1.toLowerCase();
    if (this.currentVariant.option2 && !variantColor) variantColor = this.currentVariant.option2.toLowerCase();
  }

  if (!variantColor) return;

  // ── 2. Read the layout Shopify set on the gallery element ──────────────────
  const galleryRoot = document.querySelector('[data-desktop-layout]');
  const desktopLayout = galleryRoot ? galleryRoot.getAttribute('data-desktop-layout') : '';
  // stacked | columns | thumbnail (bottom) | thumbnail_slider (side)

  const isSide       = desktopLayout === 'thumbnail_slider'; // Thumbnail Side
  const isThumbBot   = desktopLayout === 'thumbnail';        // Thumbnails Bottom
  const isGrid       = desktopLayout === 'stacked' || desktopLayout === 'columns'; // grid layouts

  // ── 3. Destroy previous Swipers ────────────────────────────────────────────
  if (this.mainSwiper) { this.mainSwiper.destroy(true, true); this.mainSwiper = null; }
  if (this.thumbSwiper) { this.thumbSwiper.destroy(true, true); this.thumbSwiper = null; }

  // ── 4. Helpers ─────────────────────────────────────────────────────────────
  // Slides of the gallery this method rebuilds (the first .product__media-list
  // on the page) only. The first #all-product-slides is that gallery's own; a
  // quick view opened on the page adds another product's at the end of body.
  const slidesRoot = document.querySelector('#all-product-slides');

  function getMatchingMainSlides(color) {
    const all = slidesRoot ? [...slidesRoot.querySelectorAll('.product__media-item')] : [];
    return matatSlidesForColor(all, color);
  }

  function getMatchingThumbSlides(color) {
    const all = slidesRoot ? [...slidesRoot.querySelectorAll('.thumbnail-list__item')] : [];
    return matatSlidesForColor(all, color);
  }

  // ── 5a. Grid layouts: Stacked / 2-columns ─────────────────────────────────
  //    Desktop = CSS grid (no Swiper). Mobile = Swiper slider.
  if (isGrid) {
    const mediaList = document.querySelector('.product__media-list');
    if (!mediaList) return;

    // 1. Remove any previously injected grid items
    mediaList.querySelectorAll('.product__media-item.variant-injected').forEach(el => el.remove());

    // 2. Populate swiper-wrapper for mobile Swiper
    const swiperWrapper = mediaList.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      swiperWrapper.innerHTML = '';
      getMatchingMainSlides(variantColor).forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('swiper-slide', 'variant-injected');
        swiperWrapper.appendChild(clone);
      });
    }

    // 3. On DESKTOP: also inject as direct children so the CSS grid renders them
    //    Hide swiper-wrapper on desktop so only grid items are visible
    if (window.innerWidth > 749) {
      if (swiperWrapper) swiperWrapper.style.display = 'none';
      getMatchingMainSlides(variantColor).forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('variant-injected');
        // Remove swiper-slide class so it doesn't get styled as a swiper slide
        clone.classList.remove('swiper-slide');
        mediaList.appendChild(clone);
      });
      // Ensure navigation arrows are hidden for grid layout on desktop
      document.querySelectorAll('.product__media-list .swiper-button-next, .product__media-list .swiper-button-prev').forEach(btn => btn.style.display = 'none');
    } else {
      // 4. Mobile: restore swiper-wrapper visibility and init Swiper
      if (swiperWrapper) swiperWrapper.style.display = '';
      document.querySelectorAll('.product__media-list .swiper-button-next, .product__media-list .swiper-button-prev').forEach(btn => btn.style.display = '');

      if (typeof mobileSwiper !== 'undefined' && mobileSwiper !== null) {
        mobileSwiper.destroy(true, true);
        mobileSwiper = null;
      }
      mobileSwiper = new Swiper('.product__media-list', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        rtl: true,
        observer: true,
        observeParents: true,
        pagination: { el: '.swiper-pagination', clickable: true },
      });
    }
    return;
  }

  // ── 5b. Thumbnail Bottom layout ───────────────────────────────────────────
  //    Desktop = main Swiper + horizontal thumb Swiper below.
  if (isThumbBot) {
    // Ensure nav arrows are visible for this layout
    document.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(btn => btn.style.display = '');

    const mainWrapper = document.querySelector('.product-slider-gallery .swiper-wrapper');
    if (mainWrapper) {
      mainWrapper.innerHTML = '';
      getMatchingMainSlides(variantColor).forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('swiper-slide');
        mainWrapper.appendChild(clone);
      });
    }

    const thumbWrapper = document.querySelector('.thumbnail_slider_bottom .swiper-wrapper');
    if (thumbWrapper) {
      thumbWrapper.innerHTML = '';
      getMatchingThumbSlides(variantColor).forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('swiper-slide');
        thumbWrapper.appendChild(clone);
      });
    }

    this.thumbSwiper = new Swiper('.thumbnail_slider_bottom', {
      slidesPerView: 4,
      spaceBetween: 8,
      watchSlidesProgress: true,
      rtl: true,
    });

    this.mainSwiper = new Swiper('.product-slider-gallery', {
      spaceBetween: 0,
      rtl: true,
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      thumbs: { swiper: this.thumbSwiper },
    });

    this.mainSwiper.slideTo(0);
    this.thumbSwiper.slideTo(0);

    // Mobile Swiper
    if (window.innerWidth <= 749) {
      if (typeof mobileSwiper !== 'undefined' && mobileSwiper !== null) {
        mobileSwiper.destroy(true, true);
        mobileSwiper = null;
      }
      mobileSwiper = new Swiper('.product__media-list', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        rtl: true,
        observer: true,
        observeParents: true,
        pagination: { el: '.swiper-pagination', clickable: true },
      });
    }
    return;
  }

  // ── 5c. Thumbnail Side layout (default / working state) ───────────────────
  const mainWrapper = document.querySelector('.product__media-list .swiper-wrapper');
  if (mainWrapper) {
    mainWrapper.innerHTML = '';
    getMatchingMainSlides(variantColor).forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('swiper-slide');
      mainWrapper.appendChild(clone);
    });
  }

  const thumbWrapper = document.querySelector('.thumbnail_slider_side .swiper-wrapper');
  if (thumbWrapper) {
    thumbWrapper.innerHTML = '';
    getMatchingThumbSlides(variantColor).forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('swiper-slide');
      thumbWrapper.appendChild(clone);
    });
  }

  this.thumbSwiper = new Swiper('.thumbnail_slider_side', {
    slidesPerView: 4,
    watchSlidesProgress: true,
    direction: 'vertical',
    rtl: true,
  });

  this.mainSwiper = new Swiper('.product-slider-gallery', {
    spaceBetween: 0,
    rtl: true,
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    thumbs: { swiper: this.thumbSwiper },
  });

  this.mainSwiper.slideTo(0);
  this.thumbSwiper.slideTo(0);

  // Mobile Swiper
  if (window.innerWidth <= 749) {
    if (typeof mobileSwiper !== 'undefined' && mobileSwiper !== null) {
      mobileSwiper.destroy(true, true);
      mobileSwiper = null;
    }
    mobileSwiper = new Swiper('.product__media-list', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      rtl: true,
      observer: true,
      observeParents: true,
      pagination: { el: '.swiper-pagination', clickable: true },
    });
  }
}


  updateSingleMedia(color) {
    const single_variant_data = this.getVariantData().find(variant => variant.title.includes(color));
    const variant_img_src = single_variant_data.featured_image? single_variant_data.featured_image.src : false;

    return variant_img_src;
  }

  getVariantDetails(color) {
    return this.getVariantData().filter(data=>data.title.includes(color));
  }

  updateURL() {
    const product_card = this.closest('.product-card_inline-variation');
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || product_card) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        // input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        if(document.querySelector(".product--giftcard")){
          document.querySelector(".product--giftcard").querySelectorAll(".price__container .price__regular .price-item--regular").forEach((e) =>{
            e.innerHTML = this.currentVariant.title;
          })
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // price change
      let $current_var_price = (this.currentVariant.price / 100).toFixed(2);
      let $current_var_price_money = `${$current_var_price} ₪`;
      let $compare_at = this.currentVariant.compare_at_price;
      let hasCompare = $compare_at && $compare_at > this.currentVariant.price;
      let $compare_html = '';
      if (hasCompare) {
        let $compareFormatted = ($compare_at / 100).toFixed(2);
        $compare_html = `${$compareFormatted} ₪`;
      }
      const wrapper = document.querySelector(".product__info-wrapper");
      if (wrapper) {
        wrapper.querySelectorAll(".change-price").forEach((e) => {
          e.innerHTML = $current_var_price_money;
        });
        const priceDiv = wrapper.querySelector(".price");
        if (priceDiv) {
          priceDiv.classList.toggle("price--on-sale", hasCompare);
        }
        const saleCompare = wrapper.querySelector(".price__sale s.price-item--regular");
        if (saleCompare) {
          saleCompare.textContent = hasCompare ? $compare_html : '';
          const saleSpan = saleCompare.closest('span');
          if (saleSpan) saleSpan.style.display = hasCompare ? '' : 'none';
        }
      }
    }
  }

  updateVariantStatuses() {
    const product_card = this.closest('.product-card_inline-variation');
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      if(inputWrappers[index - 1].querySelector(':checked')){
  
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
         const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
        if(product_card && option.classList.contains('visually-hidden')) {
          product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
          const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
          this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
        }
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      console.log('Here');
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    const product_card = this.closest('.product-card_inline-variation');

    if (!section || product_card) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const product_card = this.closest('.product-card_inline-variation');

    if(product_card) {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const raw_html = new DOMParser().parseFromString(responseText, 'text/html');
        const html = raw_html.querySelector('.single_main_product_wrapper');

        // const destination = document.getElementById(`price-${this.dataset.section}`);
        // const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        // const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // if (source && destination) destination.innerHTML = source.innerHTML;
        // if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        // if (skuSource && skuDestination) {
        //   skuDestination.innerHTML = skuSource.innerHTML;
        //   skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        // }

        // const price = document.getElementById(`price-${this.dataset.section}`);

        // if (price) price.classList.remove('visibility-hidden');

        // if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.querySelector('.product-form__buttons .product-form__submit');
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    } else {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.className = source.className;
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        //Sale Detected
        if(html.getElementById(`product-form-${this.dataset.section}`)){
          if(html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`)){
            const isSale = html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`);
            if(isSale){
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "inline-block";
            }else{
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "none";
            }
          }
        }
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "inline-block";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.add("active");
          addButton.classList.add("hidden");
          addButton.closest(".product-form-main-container-outer").classList.add("backinstock-active-main");
          addButton.closest("product-form").classList.add("backinstock-active");
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "none";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.remove("active");
          addButton.classList.remove("hidden");
          addButton.closest(".product-form-main-container-outer").classList.remove("backinstock-active-main");
          addButton.closest("product-form").classList.remove("backinstock-active");
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      var xx = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if(xx){
        if(xx.closest("fieldset") && xx.closest("fieldset").querySelector("legend span")){
            xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
          }
        return xx.value;
      }else{
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
      this.classList.add('product-recommendations--loaded');
 
            var container = document.querySelector('#recomendation');
            var productItems = container.querySelectorAll('.grid__item');
            var isMobile = window.innerWidth <= 989;
            var isdesktop = window.innerWidth >= 989;
            // Initialize main recommendation slider
            if (isMobile || productItems.length > 4) {
              new Flickity(container, {
                rightToLeft: true,
                cellAlign: 'right',
                groupCells: true,
                pageDots: false,
                wrapAround: false,
                contain: true,
                prevNextButtons: true,
                responsive: [
                  {
                    breakpoint: 750,
                    settings: {
                      groupCells: true,
                      wrapAround: false,
                      contain: true,
                      prevNextButtons: true,
                      pageDots: false
                    }
                  }
                ]
              });
            }
            // Nested image sliders inside recommendation
            document.querySelectorAll("#recomendation .enable_image_slider .flickity_grid").forEach((elementItem) => {
              var innerItems = elementItem.querySelectorAll('.grid__item');
              if (isMobile || isdesktop || innerItems.length > 4) {
                MatatCardImageSlider.setup(elementItem, {
                  imagesLoaded: true,
                  rightToLeft: true,
                  cellAlign: 'right',
                  pageDots: false,
                  wrapAround: false,
                  draggable: false,
                  contain: true,
                  responsive: [
                    {
                      breakpoint: 750,
                      settings: {
                        freeScroll: true,
                        wrapAround: false,
                        contain: true,
                        prevNextButtons: true,
                        draggable: false,
                        pageDots: false
                      }
                    }
                  ]
                });
              }
            });
              const quickViewButtons = document.querySelectorAll(".mobile-quickview");
                if (quickViewButtons.length > 0) {
                    quickViewButtons.forEach((button) => {
                      button.addEventListener("click", (evt) => {
                        evt.preventDefault();
                        const cardWrapper = evt.target.closest(".card-wrapper");
                        if (!cardWrapper) return;
                        const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
                        quickAddButton?.click();
                        
                        const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='מידה']");
                        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
                  
                        if (mobilePopupElement) {
                          const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
                          if (variationContainer && variantRadios) {
                            mobilePopupElement.classList.add("active");
                            let sizeVariantsHTML = "";
                            cardWrapper.querySelectorAll(".product-card_inline-variation input[name='מידה']").forEach((input) => {
                              let $disableClass;
                              if(input.classList.contains("disabled")){
                                $disableClass = "disabled";
                              }
                              sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
                            });
                            variationContainer.innerHTML = sizeVariantsHTML;
                          }
                        }
                      });
                    });
                  }
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

if(window.innerWidth < 750){
  // if(!document.querySelector(".gift-card-single-main-product")){
  //   if(document.querySelector(".single_main_product_wrapper")){
  //     var flkty = new Flickity( '.product__media-list.contains-media', {
  //       "imagesLoaded": true,
  //       "rightToLeft":true,
  //       "cellAlign":"right",
  //       "pageDots": true,
  //       "prevNextButtons": false,
  //       "wrapAround": true
  //   });
  //   }
  // }
  if(document.querySelector(".matat-mobile-zoom-btn")){
    document.querySelector(".matat-mobile-zoom-btn").addEventListener("click", (e)=>{
      document.querySelector(".product__media-wrapper .product__media-item.is-selected img").click()
    })
  }
}
if(document.querySelector(".matat-mobile-zoom-btn")){
    document.querySelector(".matat-mobile-zoom-btn").addEventListener("click", (e)=>{
      document.querySelector(".product__media-wrapper .product__media-item.is-selected img").click()
    })
  }
  
if(document.querySelector(".backinstock_feature_enable")){

  // backin stock feature for product page
if(document.querySelector(".single-main-product-page")){
  function validatePhoneNumber() {
    const phoneNumber = document.getElementById('stock-phone').value.trim();
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }

  window.initBackInStockHandlers = function(root) {
    root = root || document;
    var phoneInput = root.querySelector('#stock-phone');
    if (phoneInput && !phoneInput.dataset.bisInit) {
      phoneInput.dataset.bisInit = '1';
      phoneInput.addEventListener("keyup", function(e) {
        if (e.target.value != "") {
          validatePhoneNumber();
        } else {
          var msg = root.querySelector('#phoneValidationMsg');
          if (msg) msg.textContent = "";
        }
      });
    }

    var submitBtn = root.querySelector('.matat-stock-notify-submit');
    if (submitBtn && !submitBtn.dataset.bisInit) {
      submitBtn.dataset.bisInit = '1';
      submitBtn.addEventListener("click", function() {
        document.getElementById('phoneValidationMsg').textContent = '';
        document.getElementById('phoneValidationMsg').style.color = '';
        var check_phone = validatePhoneNumber();
        if (check_phone) {
          var button = this;
          var data = {
            phone: document.getElementById("stock-phone").value,
            dialCode: "972",
            id: button.getAttribute("data-id"),
            product_id: button.getAttribute("data-product_id"),
            action: button.getAttribute("data-action"),
            title: button.getAttribute("data-title"),
            price_varies: JSON.parse(button.getAttribute("data-price_varies")),
            price: button.getAttribute("data-price"),
            price_max: button.getAttribute("data-price_max"),
            price_min: button.getAttribute("data-price_min"),
            has_only_default_variant: JSON.parse(button.getAttribute("data-has_only_default_variant")),
            src: button.getAttribute("data-src"),
            url: button.getAttribute("data-url"),
            user_id: button.getAttribute("data-user_id"),
            email: button.getAttribute("data-email"),
            full_name: button.getAttribute("data-full_name"),
            variant_id: button.getAttribute("data-variant-id"),
            variant_title: button.getAttribute("data-variant-title")
          };
          // Live site URL: the myshopify.com address redirects here, and the browser blocks that redirect
          fetch('https://republic-store.com/apps/text-me/restock-notifications', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "x-shopify-shop-domain": Shopify.shop
            },
            body: JSON.stringify(data)
          })
          .then(function(response) {
            if (!response.ok) throw new Error('Network response was not ok');
          })
          .then(function() {
            document.getElementById('phoneValidationMsg').style.color = "green";
            document.getElementById('phoneValidationMsg').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
          })
          .catch(function(error) {
            console.error('Error:', error);
            document.getElementById('phoneValidationMsg').textContent = 'אירעה שגיאה. אנא נסו שוב.';
          });
        } else {
          document.getElementById('phoneValidationMsg').textContent = "'מספר טלפון לא תקין.";
        }
      });
    }

    var variantInput = root.querySelector('.product-form [name="id"]');
    if (variantInput && !variantInput.dataset.bisInit) {
      variantInput.dataset.bisInit = '1';
      variantInput.addEventListener("change", function(e) {
        var variant_change_val = e.target.value;
        var notifyBtn = root.querySelector('.matat-stock-notify-submit');
        if (notifyBtn) {
          notifyBtn.setAttribute("data-variant-id", variant_change_val);
          notifyBtn.setAttribute("data-id", variant_change_val);
        }
      });
    }
  }

  initBackInStockHandlers(document);
}
// collection page back in stack
class BackinStockmatat extends HTMLElement{
  constructor() {
  super();
  // Keyboard accessible "notify me" button (custom element: needs role, tabindex and Enter/Space)
  if (!this.hasAttribute("role")) this.setAttribute("role", "button");
  if (!this.hasAttribute("tabindex")) this.setAttribute("tabindex", "0");
  this.setAttribute("aria-haspopup", "dialog");
  this.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    this.click();
  });
  this.addEventListener("click", () => {
    const container = document.querySelector(".matat-product-card-stock");
    container.classList.toggle("active");
    document.body.classList.toggle("overflow-hidden");
    let $AllAttributes = this.attributes;
    this.copyAttributes($AllAttributes);
    if (container.classList.contains("active")) {
      const popup = container.querySelector("matat-stock-popup");
      popup.openedBy = this;
      trapFocus(container, popup.input || container);
    }
  })
}

copyAttributes(att){
  [...att].forEach((name) => {
    // Only product data: the button's own a11y attributes must not leak onto the popup
    if(name.nodeName != "class" && !["role", "tabindex", "aria-haspopup"].includes(name.nodeName)){
      document.querySelector("matat-stock-popup").setAttribute(name.nodeName,name.nodeValue);
    }
  })
}

}
customElements.define('matat-stock', BackinStockmatat);

// stock popup js starts from here
class matatStockPopup extends HTMLElement{
  constructor() {
    super();
    this.close = this.querySelector(".close-stock-popup");
    this.button = this.querySelector(".stock-popup-button");
    this.input = this.querySelector("#stock-phone-popup");
    this.close.addEventListener("click", () => {
      this.closePopup();
    })
    this.button.addEventListener("click", (evt) => {
        this.submitStock(evt.target)
    })
    this.addEventListener("click", (evt) => {
      if(evt.target == this){
        this.closePopup();
      }
    })
    document.addEventListener("keydown", (evt) => {
      if (evt.key === "Escape" && this.closest(".matat-product-card-stock").classList.contains("active")) this.closePopup();
    })
  }

  closePopup() {
    this.closest(".matat-product-card-stock").classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    // Release the focus trap and return focus to the "notify me" button that opened the popup
    removeTrapFocus(this.openedBy);
    this.openedBy = null;
  }

  validatePhoneNumber(number) {
    // Get and trim phone number input
    const phoneNumber = number.trim();
    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }

  submitStock(ele){
  document.getElementById('popup_phoneValidation').textContent = '';   
  let check_phone = this.validatePhoneNumber(this.input.value);
  if (check_phone) {
              // Get data attributes from the button
              const datas = this;
              const data = {
                  phone: this.input.value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: datas.getAttribute("data-id"),
                  product_id: datas.getAttribute("data-product_id"),
                  action: datas.getAttribute("data-action"),
                  title: (datas.getAttribute("data-title")),
                  price_varies: JSON.parse(datas.getAttribute("data-price_varies")),
                  price: (datas.getAttribute("data-price")),
                  price_max: (datas.getAttribute("data-price_max")),
                  price_min: (datas.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(datas.getAttribute("data-has_only_default_variant")),
                  src: datas.getAttribute("data-src"),
                  url: datas.getAttribute("data-url"),
                  user_id: datas.getAttribute("data-user_id"),
                  email: datas.getAttribute("data-email"),
                  full_name: datas.getAttribute("data-full_name"),
                  variant_id: datas.getAttribute("data-variant-id"),
                  variant_title: datas.getAttribute("data-variant-title")
              };

              fetch('https://republic-store.com/apps/text-me/restock-notifications', {
                  method: 'POST', 
                  headers: {
                      'Content-Type': 'application/json',
                      "x-shopify-shop-domain": Shopify.shop
                  },
                  body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      document.getElementById('popup_phoneValidation').textContent = "תגובת הרשת לא הייתה בסדר";
                      setTimeout(() => this.closePopup(), 500);  
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('popup_phoneValidation').classList.add("sucess");
                this.displaySuccessMessage("אנו נחזור אליך בהקדם האפשרי, תודה ששלחת");
                document.getElementById('popup_phoneValidation').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
                setTimeout(() => this.closePopup(), 200);  
                
              })
              .catch(error => {
                  console.error('Error:', error);
              });
      } else {
        document.getElementById('popup_phoneValidation').classList.remove("sucess");
          document.getElementById('popup_phoneValidation').textContent = "מספר טלפון לא תקין.";
      }
  }
  displaySuccessMessage(message) {
    this.displayAlertMessage(message, "success");
  }
  displayAlertMessage(message, type = "error") {
    const alertBox = document.createElement("div");
    alertBox.classList.add("alert-box", type);
    alertBox.textContent = message;

    document.body.appendChild(alertBox);

    setTimeout(() => {
        alertBox.remove();
    }, 5000); // Remove after 5 seconds
  } 
}
customElements.define('matat-stock-popup', matatStockPopup);

}


// login drawer focused css
// const loginPhoneInput = document.querySelector(".matat-login-main #login_phone");
// const otp_codeInput = document.querySelector(".matat-login-main #login_otp");
// const login_page_phoneInput = document.querySelector(".customer.login .matat-login-main #login_phone");
// const login_page_otp_codeInput = document.querySelector(".customer.login .matat-login-main #login_otp");
const toggleFocusClass = (e) => {
  if(e.target.closest(".floating_input_wrap")){
    e.target.closest(".floating_input_wrap").classList.toggle("focused", e.type === "focus");
  }
  if(e.type == "blur" && e.target.value != ""){
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.add("populated");
    }
  }else{
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.remove("populated");
    }
    
  }
};
document.querySelectorAll(".form-control").forEach((evt) => {
  evt.addEventListener("focus", toggleFocusClass);
  evt.addEventListener("blur", toggleFocusClass);
})

class GoogleLoginBtn extends HTMLElement{
  constructor() {
    super();
    this.querySelector(".google-button").addEventListener('click', () => {
      document.querySelector("#google-login").click();
    })
  }

}
customElements.define('button-google', GoogleLoginBtn);
document.addEventListener("click", (e) =>{
  if(e.target.classList.contains("modal-overlay") && e.target.closest("details") && e.target.closest("details").hasAttribute("open")){
      e.target.closest("details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
  }
  if(e.target.classList.contains("extra_color_button")){
    e.target.style.display = "none";
    e.target.closest(".card-variation-color").querySelectorAll(".color-hide-plus").forEach((ele) => {
      ele.classList.remove("color-hide-plus")
    })
  }

  if(e.target.classList.contains("mobile-popup-variant")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
    let $elementVariant = document.querySelector(`#${e.target.value}`);
    var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        $elementVariant.click();
        $elementVariant.dispatchEvent(evt);
  }
  if(e.target.classList.contains("product-vars-inner-main-popup")){
    e.target.classList.remove("active");
  }
  if(e.target.classList.contains("variant_popup_close_mobile") || e.target.closest(".variant_popup_close_mobile")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
  }
  // mobile quick view js starts from here
  if(e.target.classList.contains("mobile-quickview") || e.target.closest(".mobile-quickview")){
      e.preventDefault();
      // const quickViewButtons = document.querySelectorAll(".mobile-quickview");
      // if (quickViewButtons.length > 0) {
        // quickViewButtons.forEach((button) => {
          // button.addEventListener("click", (evt) => {
          // });
        // });
      // }
      const cardWrapper = e.target.closest(".card-wrapper");
        if (!cardWrapper) return;
        const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
        quickAddButton?.click();
        
        const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='size']");
        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
        if(variantRadios){
          if (mobilePopupElement) {
            const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
            if (variationContainer && variantRadios) {
              mobilePopupElement.classList.add("active");
              let sizeVariantsHTML = "";
              cardWrapper.querySelectorAll(".product-card_inline-variation input[name='size']").forEach((input) => {
                let $disableClass;
                if(input.classList.contains("disabled")){
                  $disableClass = "disabled";
                }
                sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
              });
              variationContainer.innerHTML = sizeVariantsHTML;
            }
          }
        }
        else{
           var defaultRadio = cardWrapper.querySelector(".card__inner .product_quick_add_wrap .default_variant_card input[type='radio']");
           if(defaultRadio) defaultRadio.click();
        }        
    }
  // ends here
})
document.addEventListener("DOMContentLoaded", (event) => {
  //   document.querySelector(".header-icon-search-mobile").addEventListener("click", ()=>{
  //   if(document.querySelector(".header__search details").hasAttribute("open")){
  //     document.querySelector(".section-header").classList.remove("menu-open");
  //   }else{
  //     document.querySelector(".section-header").classList.add("menu-open");
  //   }
  //   if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
  //     document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
  //     document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
  //     document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
  //     document.body.classList.remove("overflow-hidden-tablet")
  //   }
  //  }) 
   if(document.body.classList.contains("product-template")){
    function scrollToTop() {
      window.scrollTo(0, 0);
    }
      scrollToTop()
   }
});


// ========navigation scroll

// if(document.querySelector(".announcement-bar-section")){
//   let annoucement_bar = document.querySelector(".announcement-bar-section").offsetHeight;
//   let header_height = document.querySelector(".shopify-section-group-header-group.section-header").offsetHeight;
//   let Total_height = annoucement_bar + header_height;
//   let height_REM = Total_height / 10;
//   document.querySelector("nav.menu-drawer__navigation").style.height = `calc(100dvh - ${height_REM}rem)`;
// }else{

//   let header_height = document.querySelector(".shopify-section-group-header-group.section-header").offsetHeight;
//   let height_REM = header_height / 10;
//   document.querySelector("nav.menu-drawer__navigation").style.height = `calc(100dvh - ${height_REM}rem)`;
// }

document.addEventListener("DOMContentLoaded", function () {
  // Run after all apps & sliders modify the DOM
  setTimeout(function () {
    document.querySelectorAll('[aria-hidden="true"]').forEach(function(el) {
 
      // Skip if element is focusable or interactive
      if (
        el.tagName === 'A' ||
        el.tagName === 'BUTTON' ||
        el.hasAttribute('href') ||
        el.hasAttribute('tabindex')
      ) {
        return; // leave aria-hidden for safety
      }
 
      // Remove aria-hidden for all other elements globally
      el.removeAttribute("aria-hidden");
    });
  }, 400);
});

// Search model function
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector(".search-modal");
  const toggle = document.querySelector(".modal__toggle");

  if (!modal || !toggle) return;

  // If toggle is a <summary> inside a <details>, prevent the native toggle
  const maybeSummary = toggle.tagName === "SUMMARY" ? toggle : null;
  const details = maybeSummary ? maybeSummary.closest("details") : null;

  // Open handler (toggle)
  toggle.addEventListener("click", (e) => {
    // Prevent <summary> from toggling its details automatically
    if (maybeSummary) e.preventDefault();

    e.stopPropagation();
    modal.classList.add("is-open");
    document.body.classList.add("overflow-hidden");

    // If using details, make sure it stays open too (optional)
    if (details) details.setAttribute("open", "");
  });

  // Stop clicks inside the modal from bubbling to document
  // Use pointerdown to match the document listener
  modal.addEventListener("pointerdown", (e) => {
    e.stopPropagation();
  });

  // Close when clicking/tapping anywhere outside (pointerdown catches more cases)
  document.addEventListener("pointerdown", (e) => {
    if (!modal.classList.contains("is-open")) return;

    // Get composedPath for shadow DOM compatibility
    const path = (e.composedPath && e.composedPath()) || (e.path || []);
    // Fallback checks
    const clickedInside =
      (path && path.includes(modal)) ||
      modal.contains(e.target) ||
      false;
    const clickedToggle =
      (path && path.includes(toggle)) ||
      toggle.contains(e.target) ||
      false;

    if (!clickedInside && !clickedToggle) {
      modal.classList.remove("is-open");
      document.body.classList.remove("overflow-hidden");
      if (details) details.removeAttribute("open");
    }
  });

  // The modal can be held open by the toggle (.is-open) or by predictive search
  // results ([open] / [loading]); closing must clear all of them.
  const isSearchModalOpen = () =>
    modal.classList.contains("is-open") || modal.hasAttribute("open") || modal.hasAttribute("loading");

  const closeSearchModal = () => {
    const hadFocus = modal.contains(document.activeElement);
    modal.classList.remove("is-open");
    document.body.classList.remove("overflow-hidden");
    if (details) details.removeAttribute("open");
    const predictiveSearch = toggle.querySelector("predictive-search");
    if (predictiveSearch && typeof predictiveSearch.close === "function") predictiveSearch.close();
    modal.removeAttribute("open");
    modal.removeAttribute("loading");
    // Keyboard users: keep focus in the search bar instead of losing it with the hidden modal
    // (not the input itself - focusing it would reopen the results)
    if (hadFocus) toggle.querySelector(".search__button")?.focus();
  };

  const closeBtn = document.querySelector(".search-modal__close-button");
  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      closeSearchModal();
    });
  }

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isSearchModalOpen()) closeSearchModal();
  });
});


// card product image update
(function () {
  // ─── Helper: Clean Shopify CDN URL ───────────────────────────
  function cleanUrl(src) {
    if (!src) return '';
    if (src.startsWith('//')) src = 'https:' + src;
    return src.replace(/[?&]width=\d+/g, '').replace(/[?&]$/, '');
  }

  // ─── Helper: Build srcset string ─────────────────────────────
  function buildSrcset(src) {
    const base = cleanUrl(src);
    const sep = base.includes('?') ? '&' : '?';
    return [940, 1066, 1200, 1400, 1800, 2100]
      .map(w => `${base}${sep}width=${w} ${w}w`)
      .join(', ');
  }

  // ─── Helper: Extract color from alt text ─────────────────────
  // Supports both:
  //   "שָׁחוֹר"              → direct match
  //   "שָׁחוֹר--שלום"        → extract part before OR after --
  // Every "--" separated segment, normalised. The product page gallery puts
  // the color AFTER "--" ("front--Black"), older card code expected it BEFORE
  // ("Black--front"); matching any segment accepts both, plus a plain "Black".
  // card-product.liquid applies the same rule when it renders the slider.
  function getColorsFromAlt(alt) {
    if (!alt) return [];
    return alt.split('--').map(normalizeColorName).filter(Boolean);
  }

  // Also accepts the current format, "Product name-Black": the alt ends with
  // "-" and the color. A longer option value that also ends the alt wins, so
  // "Name-שחור-לבן" belongs to "שחור-לבן" and not to "לבן" - the same rule as
  // media-alt-color.liquid on the product page.
  function altNamesColor(alt, colorNorm, optionValuesNorm) {
    if (!colorNorm) return false;
    if (getColorsFromAlt(alt).includes(colorNorm)) return true;

    const altNorm = normalizeColorName(alt);
    if (!altNorm.endsWith('-' + colorNorm)) return false;
    return !(optionValuesNorm || []).some(value =>
      value.length > colorNorm.length && (altNorm === value || altNorm.endsWith('-' + value))
    );
  }

  // ─── Helper: Normalize a color name for comparison ────────────
  // Strips diacritics (e.g. Hebrew niqqud), case and whitespace so
  // filter values and product option values match reliably.
  function normalizeColorName(str) {
    return (str || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  // ─── Helper: Normalize an rgb() color string for comparison ──
  function normalizeRgb(str) {
    return (str || '').toString().replace(/\s+/g, '');
  }

  // ─── Helper: Parse a CSS color into an [r, g, b] triplet ─────
  function parseRgbTriplet(str) {
    const value = (str || '').toString().trim();
    if (!value) return null;

    const hex = value.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (hex) {
      let h = hex[1];
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      return [
        parseInt(h.slice(0, 2), 16),
        parseInt(h.slice(2, 4), 16),
        parseInt(h.slice(4, 6), 16),
      ];
    }

    const nums = value.match(/\d+(\.\d+)?/g);
    if (nums && nums.length >= 3) {
      return [Number(nums[0]), Number(nums[1]), Number(nums[2])];
    }
    return null;
  }

  // ─── Helper: Distance between two CSS colors ─────────────────
  function colorDistance(a, b) {
    const x = parseRgbTriplet(a);
    const y = parseRgbTriplet(b);
    if (!x || !y) return Infinity;
    const dr = x[0] - y[0];
    const dg = x[1] - y[1];
    const db = x[2] - y[2];
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }

  // A grouped filter value carries the group's swatch color, which is close
  // to but rarely identical to any one product's swatch, so allow the
  // nearest swatch within this distance to count as a match.
  const GROUPED_COLOR_MAX_DISTANCE = 75;

  // ─── Helper: Get product images JSON ─────────────────────────
  function getProductImages(cardWrapper) {
    try {
      const scripts = cardWrapper.querySelectorAll('script[type="application/json"]');
      for (const script of scripts) {
        try {
          const parsed = JSON.parse(script.textContent);
          if (parsed.images && Array.isArray(parsed.images)) {
            return parsed.images;
          }
        } catch (e) {}
      }
    } catch (e) {}
    return [];
  }

  // ─── Helper: Get variants JSON ───────────────────────────────
  // The card also prints `product.variants | json`. Each variant carries
  // its option values and its own featured_image, which is how we find a
  // color's image when the image alt text does not name the color.
  function getProductVariants(cardWrapper) {
    try {
      const scripts = cardWrapper.querySelectorAll('script[type="application/json"]');
      for (const script of scripts) {
        try {
          const parsed = JSON.parse(script.textContent);
          if (Array.isArray(parsed) && parsed.length && parsed[0] && 'option1' in parsed[0]) {
            return parsed;
          }
          if (parsed.variants && Array.isArray(parsed.variants) && parsed.variants.length) {
            return parsed.variants;
          }
        } catch (e) {}
      }
    } catch (e) {}
    return [];
  }

  // ─── Helper: Compare two CDN urls ignoring size/query ────────
  function imagePathKey(src) {
    const base = cleanUrl(src);
    try {
      return new URL(base, window.location.href).pathname;
    } catch (e) {
      return base.split('?')[0];
    }
  }

  // ─── Core: Resolve a color to its images through the variants ─
  function getVariantImagesForColor(cardWrapper, selectedColor) {
    const target = normalizeColorName(selectedColor);
    const variants = getProductVariants(cardWrapper);
    if (!variants.length) return null;

    let match = null;
    for (const variant of variants) {
      const options = variant.options && variant.options.length
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];
      const isColor = options.some(option => normalizeColorName(option) === target);
      if (!isColor || !variant.featured_image || !variant.featured_image.src) continue;
      // Prefer an in-stock variant, but keep the first match as a fallback.
      if (!match) match = variant;
      if (variant.available) {
        match = variant;
        break;
      }
    }
    if (!match) return null;

    const mainImage = {
      id: match.featured_image.id,
      url: match.featured_image.src,
      alt: match.featured_image.alt || ''
    };

    // Hover image = the gallery image that follows the variant image.
    let hoverImage = mainImage;
    const images = getProductImages(cardWrapper);
    const index = images.findIndex(image => image.id === mainImage.id);
    if (index !== -1 && images[index + 1]) hoverImage = images[index + 1];

    return { main: mainImage, hover: hoverImage };
  }

  // ─── Core: Move a carousel card to the color's slide ──────────
  // Carousel cards already render every image, so swapping the <img>
  // src would duplicate slides — select the matching cell instead.
  function selectCarouselSlide(cardWrapper, src) {
    const slider = cardWrapper.querySelector('.flickity_grid');
    if (!slider || typeof Flickity === 'undefined' || !Flickity.data) return false;
    const flkty = Flickity.data(slider);
    if (!flkty) return false;

    const targetKey = imagePathKey(src);
    const cells = slider.querySelectorAll('.pro-media');
    for (let i = 0; i < cells.length; i++) {
      const img = cells[i].querySelector('img');
      if (img && imagePathKey(img.getAttribute('src')) === targetKey) {
        flkty.select(i, false, true);
        return true;
      }
    }
    return false;
  }

  // ─── Helper: Every option value of the card's variants ───────
  // Normalised, for altNamesColor() to tell "לבן" from a longer "שחור-לבן".
  function getProductOptionValues(cardWrapper) {
    const values = new Set();
    getProductVariants(cardWrapper).forEach(variant => {
      const options = variant.options && variant.options.length
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];
      options.forEach(option => {
        const value = normalizeColorName(option);
        if (value) values.add(value);
      });
    });
    return [...values];
  }

  // ─── Core: Every image whose alt text names the color ─────────
  // Handles "שָׁחוֹר", "שָׁחוֹר--שלום" and "Product name-שָׁחוֹר" formats. Empty
  // when no alt names the color, which is how callers know to fall back.
  function getColorImageList(cardWrapper, selectedColor) {
    const selectedColorNorm = normalizeColorName(selectedColor);
    const optionValuesNorm = getProductOptionValues(cardWrapper);
    return getProductImages(cardWrapper).filter(img => altNamesColor(img.alt, selectedColorNorm, optionValuesNorm));
  }

  // ─── Core: All images belonging to a color via variant structure ─
  // When alt text doesn't name the colors, use the variant list to find
  // the color group: each variant's featured_image marks the start of
  // its color's image block; the block ends at the next variant's
  // featured_image (or the end of the list).
  function getColorGroupImages(cardWrapper, selectedColor) {
    const target = normalizeColorName(selectedColor);
    const variants = getProductVariants(cardWrapper);
    if (!variants.length) return [];

    const allImages = getProductImages(cardWrapper);
    if (!allImages.length) return [];

    let matchVariant = null;
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      const options = v.options && v.options.length
        ? v.options
        : [v.option1, v.option2, v.option3];
      const isColor = options.some(function (opt) { return normalizeColorName(opt) === target; });
      if (!isColor || !v.featured_image || !v.featured_image.id) continue;
      if (!matchVariant) matchVariant = v;
      if (v.available) { matchVariant = v; break; }
    }
    if (!matchVariant || !matchVariant.featured_image) return [];

    const startId = matchVariant.featured_image.id;
    const startIndex = allImages.findIndex(function (img) { return img.id === startId; });
    if (startIndex === -1) return [];

    // Find the next variant's featured image to determine the end boundary.
    var endIndex = allImages.length;
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      if (v === matchVariant || !v.featured_image || !v.featured_image.id) continue;
      const idx = allImages.findIndex(function (img) { return img.id === v.featured_image.id; });
      if (idx > startIndex && idx < endIndex) endIndex = idx;
    }

    return allImages.slice(startIndex, endIndex);
  }

  // ─── Core: Rebuild a carousel card around one color ───────────
  // card-product.liquid renders only the active color's images into the
  // slider, so picking another color has to swap the slides rather than
  // move to one of them. Cells are rebuilt from the product images JSON
  // the card already prints, in the same markup Liquid produces.
  function buildCarouselCell(image, index, href) {
    const base = cleanUrl(image.url);
    const sep = base.includes('?') ? '&' : '?';

    const img = document.createElement('img');
    img.src = `${base}${sep}width=1000`;
    img.alt = image.alt || '';
    img.className = 'motion-reduce variant_image_element';

    const link = document.createElement('a');
    link.href = href;
    link.className = 'product-card-link';
    link.appendChild(img);

    const cell = document.createElement('div');
    cell.className = 'pro-media';
    cell.dataset.index = index;
    cell.dataset.imageId = image.id;
    cell.appendChild(link);
    return cell;
  }

  // After swapping carousel cells, lazy-loaded images may not have dimensions
  // yet, leaving flickity-viewport at height:0. This listens for each image to
  // load and tells Flickity to recalculate, with a fallback timeout.
  function resizeFlickityAfterImages(slider) {
    const f = (typeof Flickity !== 'undefined' && Flickity.data) ? Flickity.data(slider) : null;
    if (!f) return;
    const imgs = slider.querySelectorAll('.pro-media img');
    let pending = 0;
    imgs.forEach(function (img) {
      if (img.complete && img.naturalHeight !== 0) return;
      pending++;
      img.addEventListener('load', function () {
        pending--;
        if (pending <= 0) f.resize();
      }, { once: true });
    });
    // If all images were already cached, resize immediately. Otherwise
    // schedule a safety-net resize so the viewport can never stay at 0.
    if (pending === 0) {
      f.resize();
    } else {
      setTimeout(function () { f.resize(); }, 400);
    }
  }

  function rebuildCarouselForColor(cardWrapper, selectedColor) {
    const slider = cardWrapper.querySelector('.flikity_grid_image');
    if (!slider) return false;

    // Already holding this color - Liquid rendered it, or the same swatch was
    // clicked again. Skip the JSON parse and cell work; this is the path every
    // card takes on page load, so it has to stay this cheap.
    if (
      slider.dataset.sliderColor &&
      normalizeColorName(slider.dataset.sliderColor) === normalizeColorName(selectedColor)
    ) {
      return true;
    }

    let images = getColorImageList(cardWrapper, selectedColor);
    let filteredToColor = images.length > 0;
    // No alt names this color: use variant structure to find the color's image
    // group (from the variant's featured_image to the next variant's featured_image).
    if (!filteredToColor) {
      images = getColorGroupImages(cardWrapper, selectedColor);
      filteredToColor = images.length > 0;
    }
    if (!filteredToColor) {
      images = getProductImages(cardWrapper);
    }
    if (!images.length) return false;

    const flkty = (typeof Flickity !== 'undefined' && Flickity.data) ? Flickity.data(slider) : null;

    const currentIds = [...slider.querySelectorAll('.pro-media')].map(cell => cell.dataset.imageId);
    const nextIds = images.map(img => String(img.id));
    const sameCells = currentIds.length === nextIds.length && currentIds.every((id, i) => id === nextIds[i]);

    if (!sameCells) {
      const linkEl = slider.querySelector('.product-card-link') || cardWrapper.querySelector('.card__heading a');
      const href = linkEl ? linkEl.getAttribute('href') : '#';
      const cells = images.map((img, i) => buildCarouselCell(img, i, href));

      // Destroy old Flickity, swap cells, create fresh instance so
      // imagesLoaded:true can wait for CDN images before measuring height.
      if (flkty) {
        flkty.destroy();
      }
      slider.innerHTML = '';
      cells.forEach(cell => slider.appendChild(cell));
      // Through the gate, so a color click does not hand a slider back to a
      // breakpoint the card opted out of.
      MatatCardImageSlider.setup(slider, {
        imagesLoaded: true,
        rightToLeft: true,
        cellAlign: 'right',
        pageDots: true,
        wrapAround: true,
        draggable: false,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              freeScroll: true,
              wrapAround: false,
              contain: true,
              prevNextButtons: false,
              draggable: false,
              pageDots: true,
            },
          },
        ],
      });

      if (filteredToColor) {
        slider.dataset.sliderColor = selectedColor;
      } else {
        delete slider.dataset.sliderColor;
      }
    }

    return true;
  }

  // ─── Core: Rebuild a carousel with a linked product's images ──
  // Used for metafield color swatches (add_products_for_color_options) where
  // each color maps to a separate product whose images replace the slider.
  function rebuildCarouselForLinkedProduct(cardWrapper, images, colorName, href) {
    const slider = cardWrapper.querySelector('.flikity_grid_image');
    if (!slider || !images || !images.length) return false;

    if (
      slider.dataset.sliderColor &&
      normalizeColorName(slider.dataset.sliderColor) === normalizeColorName(colorName)
    ) {
      return true;
    }

    const flkty = (typeof Flickity !== 'undefined' && Flickity.data) ? Flickity.data(slider) : null;

    if (!href) {
      const linkEl = slider.querySelector('.product-card-link') || cardWrapper.querySelector('.card__heading a');
      href = linkEl ? linkEl.getAttribute('href') : '#';
    }
    const cells = images.map((img, i) => buildCarouselCell(img, i, href));

    if (flkty) {
      flkty.destroy();
    }
    slider.innerHTML = '';
    cells.forEach(cell => slider.appendChild(cell));
    // Through the gate, so a color click does not hand a slider back to a
    // breakpoint the card opted out of.
    MatatCardImageSlider.setup(slider, {
      imagesLoaded: true,
      rightToLeft: true,
      cellAlign: 'right',
      pageDots: true,
      wrapAround: true,
      draggable: false,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            freeScroll: true,
            wrapAround: false,
            contain: true,
            prevNextButtons: false,
            draggable: false,
            pageDots: true,
          },
        },
      ],
    });

    slider.dataset.sliderColor = colorName;
    return true;
  }

  // ─── Core: Resolve a color to its images ─────────────────────
  // 1) Images whose alt text names the color
  // 2) Falls back to the image assigned to the color's variant
  // Returns { main, hover } or null.
  function getColorImages(cardWrapper, selectedColor) {
    const colorImages = getColorImageList(cardWrapper, selectedColor);

    if (colorImages.length) {
      return {
        main: colorImages[0],
        hover: colorImages.find(img => img.id !== colorImages[0].id) || colorImages[0],
      };
    }

    return getVariantImagesForColor(cardWrapper, selectedColor);
  }

  // ─── Helper: Point one card <img> at an image ────────────────
  function applyCardImage(img, image) {
    const src = cleanUrl(image.url);
    const sep = src.includes('?') ? '&' : '?';
    img.src = `${src}${sep}width=720`;
    img.srcset = buildSrcset(src);
    img.alt = image.alt || '';
  }

  // ─── Helper: the plain featured + hover <img> pair ───────────
  // card-product.liquid renders this pair for every breakpoint the card image
  // slider does not cover, so a card can hold the pair and a slider at once -
  // and the pair is the only markup the second-image-on-hover effect works in.
  // Cards carrying both mark the pair so it can be told apart from the
  // slider's own cells; other card markup has only these two images under
  // .card__media, so fall back to them there.
  function staticCardImages(cardWrapper) {
    const mediaWrapper = cardWrapper.querySelector('.card__media');
    if (!mediaWrapper) return [];
    const marked = [...mediaWrapper.querySelectorAll('img.card__static-media')];
    if (marked.length) return marked;
    if (mediaWrapper.querySelector('.flikity_grid_image')) return [];
    return [...mediaWrapper.querySelectorAll('img.motion-reduce')];
  }

  // ─── Core: Update the plain featured + hover image pair ──────
  function updateStaticCardImages(cardWrapper, selectedColor) {
    const imgs = staticCardImages(cardWrapper);
    if (!imgs.length) return false;

    const images = getColorImages(cardWrapper, selectedColor);
    if (!images) return false;

    applyCardImage(imgs[0], images.main);
    if (imgs[1]) applyCardImage(imgs[1], images.hover);
    return true;
  }

  // ─── Core: Update card main + hover images ────────────────────
  function updateCardImages(cardWrapper, selectedColor) {
    // Both can be present: the slider holds one color at a time, and the plain
    // pair covers whichever breakpoint the slider was opted out of. Update
    // each one the card actually has.
    let updated = false;
    if (cardWrapper.querySelector('.flikity_grid_image')) {
      updated = rebuildCarouselForColor(cardWrapper, selectedColor);
    }
    if (updateStaticCardImages(cardWrapper, selectedColor)) updated = true;
    return updated;
  }

  // ─── Update sold-out state for standard variant cards ─────────
  // When a color is selected (swatch click or filter), check if all
  // variants of that color are out of stock and toggle the sold-out
  // message, classes and badge accordingly.
  function updateStandardCardSoldOut(cardWrapper, selectedColor) {
    if (!cardWrapper || !selectedColor) return;

    const variants = getProductVariants(cardWrapper);
    if (!variants.length) return;

    const target = normalizeColorName(selectedColor);
    let colorVariants = variants.filter(function (v) {
      const options = v.options && v.options.length
        ? v.options
        : [v.option1, v.option2, v.option3];
      return options.some(function (opt) { return normalizeColorName(opt) === target; });
    });
    if (!colorVariants.length) return;

    const isSoldOut = colorVariants.every(function (v) { return !v.available; });

    // Toggle sold-out-message elements
    cardWrapper.querySelectorAll('.sold-out-message').forEach(function (el) {
      el.style.display = isSoldOut ? '' : 'none';
    });

    // Toggle sold-out-pro classes
    const quickAddWrap = cardWrapper.querySelector('.product_quick_add_wrap');
    if (quickAddWrap) quickAddWrap.classList.toggle('sold-out-pro', isSoldOut);
    cardWrapper.querySelectorAll('.card__media .media').forEach(function (mediaEl) {
      mediaEl.classList.toggle('sold-out-pro', isSoldOut);
    });
    const mobileQuickview = cardWrapper.querySelector('.card-mobile-quickview');
    if (mobileQuickview) mobileQuickview.classList.toggle('sold-out-pro', isSoldOut);

    // Toggle out-of-stock badge.
    // The flag comes from data-badge-backstock on the badge wrapper - there is no global
    // `settings` object in the theme's JS, so reading one here always came back undefined
    // and hid the badge on every card this function touched.
    const outOfStockBadge = cardWrapper.querySelector('.out-of-stock');
    if (outOfStockBadge) {
      const badgeWrap = outOfStockBadge.closest('.badge-main-matat');
      const backStockEnabled =
        !!badgeWrap && badgeWrap.getAttribute('data-badge-backstock') === 'true';
      const showOutOfStock = isSoldOut && backStockEnabled;
      outOfStockBadge.style.display = showOutOfStock ? '' : 'none';
      outOfStockBadge.classList.toggle('out_of_stock_badge', showOutOfStock);
    }
  }

  // ─── Event: Color swatch clicked ─────────────────────────────
  document.addEventListener('change', function (e) {
    const colorInput = e.target.closest('.card-variation-color input[type="radio"]');
    if (!colorInput) return;

    const cardWrapper = colorInput.closest('.product-card-wrapper');
    if (!cardWrapper) return;

    // Redirect mode handles color clicks with a page navigation.
    if (matatCardUsesSwatchRedirect(cardWrapper)) return;

    updateCardImages(cardWrapper, colorInput.value);
    updateStandardCardSoldOut(cardWrapper, colorInput.value);
  });

  // ─── On page load: apply default checked color per card ───────
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-card-wrapper').forEach(function (cardWrapper) {
      const checkedInput = cardWrapper.querySelector(
        '.card-variation-color input[type="radio"]:checked'
      );
      if (checkedInput) {
        updateCardImages(cardWrapper, checkedInput.value);
        updateStandardCardSoldOut(cardWrapper, checkedInput.value);
      }
    });
  });

  // ─── Meta color swatch (add_products_for_color_options) ───────
  // When a linked-product color swatch is clicked, update the card image
  // and price in place (like the normal product color option) instead of
  // navigating away.
  function setCardMetaColorImage(cardWrapper, src, hoverSrc) {
    if (!src) return;
    // Only the plain pair - a slider's cells are rebuilt from
    // data-color-all-images instead, and must not be overwritten here.
    const allImgs = staticCardImages(cardWrapper);
    if (!allImgs.length) return;
    const mainBase = cleanUrl(src);
    const mainSep = mainBase.includes('?') ? '&' : '?';
    allImgs[0].src = `${mainBase}${mainSep}width=720`;
    allImgs[0].srcset = buildSrcset(mainBase);
    if (allImgs[1]) {
      const hoverBase = cleanUrl(hoverSrc || src);
      const hoverSep = hoverBase.includes('?') ? '&' : '?';
      allImgs[1].src = `${hoverBase}${hoverSep}width=720`;
      allImgs[1].srcset = buildSrcset(hoverBase);
    }
  }

  function setCardMetaColorPrice(cardWrapper, priceHtml, compareHtml) {
    const priceEl = cardWrapper.querySelector('.price');
    if (!priceEl) return;
    const hasCompare = !!compareHtml && compareHtml !== '';
    const regularPrice = priceEl.querySelector('.price__regular .change-price');
    const salePrice = priceEl.querySelector('.price__sale .change-price');
    const saleCompare = priceEl.querySelector('.price__sale s.price-item--regular');
    if (regularPrice) regularPrice.textContent = priceHtml;
    if (salePrice) salePrice.textContent = priceHtml;
    if (saleCompare) {
      saleCompare.textContent = hasCompare ? compareHtml : '';
      const wrapper = saleCompare.closest('span');
      if (wrapper) wrapper.style.display = hasCompare ? '' : 'none';
    }
    priceEl.classList.toggle('price--on-sale', hasCompare);
  }

  function applyMetaSwatchUpdate(cardWrapper, swatchLink) {
    const imageSrc = swatchLink.getAttribute('data-color-image');
    const hoverSrc = swatchLink.getAttribute('data-color-hover-image');
    const priceHtml = swatchLink.getAttribute('data-color-price');
    const compareHtml = swatchLink.getAttribute('data-color-compare');
    const colorUrl = swatchLink.getAttribute('data-color-url');

    if (!(imageSrc || priceHtml || colorUrl)) return false;

    const carousel = cardWrapper.querySelector('.flikity_grid_image');
    if (carousel) {
      const allImagesJson = swatchLink.getAttribute('data-color-all-images');
      if (allImagesJson) {
        try {
          const images = JSON.parse(allImagesJson);
          const colorName = swatchLink.getAttribute('data-option-item') || '';
          rebuildCarouselForLinkedProduct(cardWrapper, images, colorName, colorUrl);
        } catch (e) {}
      }
    }
    // The plain pair covers whichever breakpoint the slider does not, and is
    // the only image on a card with no slider at all - either way it needs the
    // color. A no-op when the card carries a slider on both breakpoints.
    if (imageSrc) setCardMetaColorImage(cardWrapper, imageSrc, hoverSrc);
    if (priceHtml) setCardMetaColorPrice(cardWrapper, priceHtml, compareHtml);
    if (colorUrl) {
      cardWrapper.querySelectorAll('a.card__media, .card__media a').forEach(function (a) {
        a.href = colorUrl;
      });
      const headingLink = cardWrapper.querySelector('.card__heading a');
      if (headingLink) {
        headingLink.href = colorUrl;
        const colorTitle = swatchLink.getAttribute('data-color-title');
        if (colorTitle) headingLink.textContent = colorTitle;
      }
    }

    const stockEl = cardWrapper.querySelector('matat-stock');
    if (stockEl) {
      const stockAttrs = {
        'data-id': 'data-stock-id',
        'data-product-id': 'data-stock-product-id',
        'data-title': 'data-stock-title',
        'data-price-varies': 'data-stock-price-varies',
        'data-price': 'data-stock-price',
        'data-price-max': 'data-stock-price-max',
        'data-price-min': 'data-stock-price-min',
        'data-has-only-default-variant': 'data-stock-has-only-default-variant',
        'data-src': 'data-stock-src',
        'data-url': 'data-stock-url',
        'data-variant-id': 'data-stock-variant-id',
        'data-variant-title': 'data-stock-variant-title',
      };
      Object.keys(stockAttrs).forEach(function (stockAttr) {
        const val = swatchLink.getAttribute(stockAttrs[stockAttr]);
        if (val !== null) stockEl.setAttribute(stockAttr, val);
      });
      const stockAvailable = swatchLink.getAttribute('data-stock-available');
      if (stockAvailable !== null) {
        const isSoldOut = stockAvailable !== 'true';
        const soldOutMessage = stockEl.closest('.sold-out-message');
        if (soldOutMessage) {
          soldOutMessage.style.display = isSoldOut ? '' : 'none';
        }
        const quickAddWrap = cardWrapper.querySelector('.product_quick_add_wrap');
        if (quickAddWrap) quickAddWrap.classList.toggle('sold-out-pro', isSoldOut);
        cardWrapper.querySelectorAll('.card__media .media').forEach(function (mediaEl) {
          mediaEl.classList.toggle('sold-out-pro', isSoldOut);
        });
        const mobileQuickview = cardWrapper.querySelector('.card-mobile-quickview');
        if (mobileQuickview) mobileQuickview.classList.toggle('sold-out-pro', isSoldOut);
      }
    }

    const badgeSale = swatchLink.getAttribute('data-badge-sale');
    if (badgeSale !== null) {
      const badgeWrap = cardWrapper.querySelector('.badge-main-matat');
      if (badgeWrap) {
        const isSale = badgeSale === 'true';
        const isSoldOutBadge = swatchLink.getAttribute('data-badge-soldout') === 'true';
        const backStockEnabled = swatchLink.getAttribute('data-badge-backstock') === 'true';
        const hideTags = backStockEnabled && isSoldOutBadge;

        const saleBadge = badgeWrap.querySelector('.sale');
        if (saleBadge) {
          saleBadge.classList.toggle('is-sale', isSale && !hideTags);
          saleBadge.style.display = isSale && !hideTags ? '' : 'none';
          const saleText = swatchLink.getAttribute('data-badge-sale-text');
          if (saleText) saleBadge.textContent = saleText;
        }

        const outOfStockBadge = badgeWrap.querySelector('.out-of-stock');
        if (outOfStockBadge) {
          const showOutOfStock = isSoldOutBadge && backStockEnabled;
          outOfStockBadge.style.display = showOutOfStock ? '' : 'none';
          outOfStockBadge.classList.toggle('out_of_stock_badge', showOutOfStock);
        }

        const newBadge = badgeWrap.querySelector('.new_badge');
        if (newBadge) {
          newBadge.style.display =
            swatchLink.getAttribute('data-badge-new') === 'true' && !hideTags ? '' : 'none';
        }

        const customTags = (swatchLink.getAttribute('data-badge-custom-tags') || '')
          .split('||')
          .filter(Boolean);
        badgeWrap.querySelectorAll('.best_sell_badge').forEach(function (b) {
          b.remove();
        });
        if (customTags.length && !hideTags) {
          let colorClass = '';
          const sourceEl = outOfStockBadge || saleBadge;
          if (sourceEl) {
            const colorFound = Array.from(sourceEl.classList).find(function (c) {
              return c.indexOf('color-') === 0;
            });
            colorClass = colorFound || '';
          }
          customTags.forEach(function (tag) {
            const badge = document.createElement('span');
            badge.className = 'badge-matat badge off-label best_sell_badge ' + colorClass;
            badge.textContent = tag;
            badgeWrap.insertBefore(badge, outOfStockBadge);
          });
        }
      }
    }
    // Quick-add: remember the clicked color so the quick-add modal opens
    // with it preselected (loads the linked product with its variant).
    const quickAddBtn = cardWrapper.querySelector('.product_quick_add_wrap .quick-add__submit');
    if (quickAddBtn && colorUrl) {
      quickAddBtn.setAttribute('data-product-url', colorUrl);
      const selectedColor = swatchLink.getAttribute('data-option-item');
      if (selectedColor) {
        const modalEl = cardWrapper.querySelector('quick-add-modal');
        if (modalEl) modalEl.setAttribute('data-selected_vartitle', selectedColor);
      }
    }

    markMetaSwatchActive(cardWrapper, swatchLink);
    return true;
  }

  function markMetaSwatchActive(cardWrapper, swatchLink) {
    cardWrapper.querySelectorAll('.redirection-swatch').forEach(function (li) {
      li.classList.remove('active-color');
    });
    const swatchItem = swatchLink.closest('.redirection-swatch');
    if (swatchItem) swatchItem.classList.add('active-color');
  }

  document.addEventListener('click', function (e) {
    const swatchLink = e.target.closest(
      '.card-variation-color .redirection-swatch a.variation-color'
    );
    if (!swatchLink) return;

    const cardWrapper = swatchLink.closest('.product-card-wrapper');
    if (!cardWrapper) return;

    // Redirect mode: let the browser follow the swatch link so the product
    // page opens with the clicked color preselected.
    if (matatCardUsesSwatchRedirect(cardWrapper)) return;

    if (applyMetaSwatchUpdate(cardWrapper, swatchLink)) {
      e.preventDefault();
    }
  });

  // The color filter (shopify.color-pattern) labels its values with
  // Shopify's taxonomy names, mostly English ("Gold", "Silver"), while the
  // products name their color option in Hebrew ("זהב", "כסף"), so a filter
  // label alone never matches a card's swatch. Keyed by filterColorKey().
  const FILTER_COLOR_ALIASES = {
    black: ['שחור'],
    white: ['לבן'],
    gold: ['זהב'],
    silver: ['כסף'],
    beige: ["בז'"],
    brown: ['חום'],
    gray: ['אפור'],
    grey: ['אפור'],
    green: ['ירוק'],
    blue: ['כחול'],
    navy: ['נייבי'],
    'חיל הים': ['נייבי'],
    pink: ['ורוד'],
    red: ['אדום'],
    burgundy: ['בורדו'],
    yellow: ['צהוב'],
    orange: ['כתום'],
    purple: ['סגול'],
    clear: ['שקוף'],
  };

  // normalizeColorName() plus what only differs between a filter label and a
  // product's option value: Hebrew points ("חוּם" vs "חום" - NFD does not
  // decompose them), apostrophe variants and doubled spaces.
  function filterColorKey(str) {
    return normalizeColorName(str)
      .replace(/[֑-ׇ]/g, '')
      .replace(/[’׳`]/g, "'")
      .replace(/\s+/g, ' ');
  }

  // "בז'/זהב", "זהב מט" -> ["בז'", "זהב"], ["זהב", "מט"]
  function filterColorTokens(str) {
    return filterColorKey(str).split(/\s*\/\s*|\s+/).filter(Boolean);
  }

  // Every color word the aliases know, to tell a swatch that is plainly
  // another color ("שחור זמש") from a shade they cannot name ("קפה זמש").
  const KNOWN_COLOR_WORDS = new Set();
  Object.keys(FILTER_COLOR_ALIASES).forEach(function (key) {
    KNOWN_COLOR_WORDS.add(filterColorKey(key));
    FILTER_COLOR_ALIASES[key].forEach(function (alias) {
      KNOWN_COLOR_WORDS.add(filterColorKey(alias));
    });
  });

  // Filter value + label, plus the Hebrew option names a taxonomy label
  // stands for, as filterColorKey() keys.
  function filterColorTargets(colorValue, colorLabel) {
    // The card's data-option-item usually matches the label, while the
    // submitted filter value can be a code/transliteration of it.
    const names = [colorValue];
    if (colorLabel && colorLabel !== colorValue) names.push(colorLabel);
    names.slice().forEach(function (name) {
      (FILTER_COLOR_ALIASES[filterColorKey(name)] || []).forEach(function (alias) {
        if (names.indexOf(alias) === -1) names.push(alias);
      });
    });
    return { names: names, targets: names.map(filterColorKey).filter(Boolean) };
  }

  // 3: the swatch is the color, 2: it leads with it ("זהב מט"),
  // 1: it mentions it ("שחור/זהב"), 0: no match by name.
  function swatchNameRank(link, targets) {
    const name = link.getAttribute('data-option-item');
    if (targets.indexOf(filterColorKey(name)) !== -1) return 3;
    const tokens = filterColorTokens(name);
    if (!tokens.length) return 0;
    if (targets.indexOf(tokens[0]) !== -1) return 2;
    return tokens.some(function (t) { return targets.indexOf(t) !== -1; }) ? 1 : 0;
  }

  function isOtherKnownColor(link, targets) {
    const tokens = filterColorTokens(link.getAttribute('data-option-item'));
    return (
      tokens.some(function (t) { return KNOWN_COLOR_WORDS.has(t); }) &&
      !tokens.some(function (t) { return targets.indexOf(t) !== -1; })
    );
  }

  // The swatches of the product the card was rendered for
  function ownSwatches(cardWrapper, links) {
    const id = cardWrapper.getAttribute('data-card-product-id');
    if (!id) return [];
    return links.filter(function (link) {
      return link.getAttribute('data-stock-product-id') === id;
    });
  }

  function getMetaSwatchLinks(cardWrapper) {
    return Array.from(
      cardWrapper.querySelectorAll('.meta-color-options .redirection-swatch a.variation-color')
    );
  }

  // Exposed for matat-filter.js: activate the filtered color on a card
  // (marks the matching swatch active and shows its product image).
  window.MatatCardMetaColor = {
    activate: function (cardWrapper, colorValue, colorRgb, colorLabel) {
      if (!cardWrapper || !colorValue) return false;

      const filterColor = filterColorTargets(colorValue, colorLabel);
      const names = filterColor.names;
      const targets = filterColor.targets;

      const links = getMetaSwatchLinks(cardWrapper);
      let swatch = null;

      // 1) Match the metafield swatch by color name: the color itself, then
      //    one led by it, then one that only mentions it - Gold is "זהב מט"
      //    or "בז'/זהב" on some products. The card's own color wins when it
      //    leads with the filtered color too: the filter returns every
      //    product of a family that has the color, so "זהב" and "זהב מט"
      //    each keep their own card instead of both showing "זהב".
      let bestRank = 0;
      for (let i = 0; i < links.length; i++) {
        const rank = swatchNameRank(links[i], targets);
        if (rank > bestRank) {
          bestRank = rank;
          swatch = links[i];
        }
      }
      if (swatch) {
        const own = ownSwatches(cardWrapper, links);
        for (let i = 0; i < own.length; i++) {
          const rank = swatchNameRank(own[i], targets);
          if (rank >= 2 || rank === bestRank) {
            swatch = own[i];
            break;
          }
        }
      }

      // 2) Match by swatch color (RGB) — handles names that differ
      //    between the product's option and the linked color product,
      //    and grouped filter values whose label never matches a product
      //    option (group "Gold" vs the option זהב מט). Exact match wins;
      //    otherwise the closest swatch within tolerance is used.
      if (!swatch && colorRgb) {
        const targetRgb = normalizeRgb(colorRgb);
        let closest = null;
        let closestDistance = Infinity;

        for (let i = 0; i < links.length; i++) {
          const c = links[i].style.getPropertyValue('--swatch-background-color');
          if (!c) continue;
          if (normalizeRgb(c) === targetRgb) {
            swatch = links[i];
            break;
          }
          const distance = colorDistance(c, colorRgb);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = links[i];
          }
        }

        if (!swatch && closest && closestDistance <= GROUPED_COLOR_MAX_DISTANCE) {
          swatch = closest;
        }
      }

      // 3) Match by image: find the color's image, then the swatch whose
      //    data-color-image points at the same image
      if (!swatch) {
        let images = null;
        for (let i = 0; i < names.length; i++) {
          images = getColorImages(cardWrapper, names[i]);
          if (images) break;
        }
        if (images) {
          const keys = new Set([
            imagePathKey(images.main.url),
            imagePathKey(images.hover.url),
          ]);
          for (let i = 0; i < links.length; i++) {
            const img = links[i].getAttribute('data-color-image');
            if (img && keys.has(imagePathKey(img))) {
              swatch = links[i];
              break;
            }
          }
        }
      }

      if (swatch) {
        applyMetaSwatchUpdate(cardWrapper, swatch);
        markMetaSwatchActive(cardWrapper, swatch);
        return true;
      }

      // 4) Standard variant radios (cards without metafield swatches)
      // The swatch stays marked active even when no image can be resolved,
      // so the card always shows which filtered color it matched.
      const radios = cardWrapper.querySelectorAll('.card-variation-color input[type="radio"]');
      for (let i = 0; i < radios.length; i++) {
        if (targets.indexOf(filterColorKey(radios[i].value)) !== -1) {
          radios[i].checked = true;
          updateCardImages(cardWrapper, radios[i].value);
          updateStandardCardSoldOut(cardWrapper, radios[i].value);
          return true;
        }
      }

      // 5) Last resort: swap image by matching the image alt text
      for (let i = 0; i < names.length; i++) {
        if (updateCardImages(cardWrapper, names[i])) {
          updateStandardCardSoldOut(cardWrapper, names[i]);
          return true;
        }
      }
      return false;
    },

    // For a card activate() found no match on: Shopify matches the color
    // filter against the product's whole color-pattern list, which names
    // every color of its family, so "Mindy 21 - שחור" is in Brown because
    // its sibling "קפה זמש" is - a shade no alias or swatch distance ties
    // to Brown. When the card's own color is plainly another one, show the
    // sibling that is not (the nearest to the filter's swatch if several).
    // A card whose own color could be the filtered one is left as it is.
    activateSibling: function (cardWrapper, colorValue, colorRgb, colorLabel) {
      if (!cardWrapper || !colorValue) return false;

      const targets = filterColorTargets(colorValue, colorLabel).targets;
      const links = getMetaSwatchLinks(cardWrapper);
      const own = ownSwatches(cardWrapper, links);
      if (!own.length) return false;
      if (!own.every(function (link) { return isOtherKnownColor(link, targets); })) return false;

      const candidates = links.filter(function (link) {
        return own.indexOf(link) === -1 && !isOtherKnownColor(link, targets);
      });
      if (!candidates.length) return false;

      let swatch = candidates[0];
      if (colorRgb && candidates.length > 1) {
        let closestDistance = Infinity;
        candidates.forEach(function (link) {
          const c = link.style.getPropertyValue('--swatch-background-color');
          const distance = c ? colorDistance(c, colorRgb) : Infinity;
          if (distance < closestDistance) {
            closestDistance = distance;
            swatch = link;
          }
        });
      }

      applyMetaSwatchUpdate(cardWrapper, swatch);
      markMetaSwatchActive(cardWrapper, swatch);
      return true;
    },

    // Activate the checked filter colors on a card: a match for any of them
    // first, then a sibling - so with Black and Brown both checked a black
    // card stays black rather than switching to its brown sibling.
    activateFiltered: function (cardWrapper, colors) {
      const self = this;
      const tryAll = function (method) {
        return colors.some(function (color) {
          return method.call(self, cardWrapper, color.value, color.rgb, color.label);
        });
      };
      return tryAll(self.activate) || tryAll(self.activateSibling);
    },
  };

})();

// ============================================================
// PRODUCT PAGE — META COLOR SWATCH IN-PLACE SWAP
// Swatches of the add_products_for_color_options metafield point at
// linked products. Instead of navigating away, clicking one loads the
// linked product's section HTML and swaps it in place, then re-inits
// the gallery, tabs and out-of-stock badge.
// ============================================================

function initProductTabs() {
  document.querySelectorAll('.product-tab-list').forEach(function (container) {
    if (container._matatTabsBound) return;
    container._matatTabsBound = true;
    var buttons = container.querySelectorAll('.tab-list-btn');
    var panels = container.querySelectorAll('.tab-list-panel');
    var isMobile = window.innerWidth <= 749;

    if (!isMobile) {
      if (!buttons.length || !panels.length) return;
      buttons[0].classList.add('active');
      panels[0].classList.add('active');

      buttons.forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('active'); });
          panels.forEach(function (p) { p.classList.remove('active'); });
          btn.classList.add('active');
          panels[idx].classList.add('active');
        });
      });
    } else {
      panels.forEach(function (panel) {
        var heading = panel.querySelector('.tab_heading_mobile');
        var content = panel.querySelector('.tab_content_mobile');
        if (heading && content) {
          heading.addEventListener('click', function () {
            content.classList.toggle('active');
          });
        }
      });
    }
  });
}
window.initProductTabs = initProductTabs;

subscribe(PUB_SUB_EVENTS.variantChange, function (data) {
  var payload = (data && data.data) ? data.data : data;
  if (!payload || !payload.sectionId) return;
  var badge = document.getElementById('matat-out-of-stock-' + payload.sectionId);
  if (badge && payload.variant) {
    badge.style.display = payload.variant.available ? 'none' : 'inline-block';
  }

  // Update back-in-stock button data attributes on variant change
  var sectionEl = document.getElementById('MainProduct-' + payload.sectionId);
  if (sectionEl && payload.variant) {
    var notifyBtn = sectionEl.querySelector('.matat-stock-notify-submit');
    if (notifyBtn) {
      notifyBtn.setAttribute('data-id', payload.variant.id);
      notifyBtn.setAttribute('data-variant-id', payload.variant.id);
      notifyBtn.setAttribute('data-variant-title', payload.variant.title);
      if (payload.variant.featured_image) {
        notifyBtn.setAttribute('data-src', payload.variant.featured_image);
      }
    }
    // Show/hide back-in-stock alert based on variant availability
    var backStockAlert = sectionEl.querySelector('.matat-backin-stock-alert');
    var addBtn = sectionEl.querySelector('.product-form__submit');
    if (backStockAlert && addBtn) {
      if (payload.variant.available) {
        backStockAlert.classList.remove('active');
        addBtn.classList.remove('hidden');
        var outerWrap = addBtn.closest('.product-form-main-container-outer');
        if (outerWrap) outerWrap.classList.remove('backinstock-active-main');
        var prodForm = addBtn.closest('product-form');
        if (prodForm) prodForm.classList.remove('backinstock-active');
      } else {
        backStockAlert.classList.add('active');
        addBtn.classList.add('hidden');
        var outerWrap = addBtn.closest('.product-form-main-container-outer');
        if (outerWrap) outerWrap.classList.add('backinstock-active-main');
        var prodForm = addBtn.closest('product-form');
        if (prodForm) prodForm.classList.add('backinstock-active');
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  initProductTabs();
});

document.addEventListener('click', function (e) {
  var swatchLink = e.target.closest(
    '.color-main-meta-option .meta-color-options .redirection-swatch a'
  );
  if (!swatchLink) return;

  var swatchLi = swatchLink.closest('.redirection-swatch');
  var fieldset = swatchLink.closest('.color-main-meta-option');
  var sectionId = fieldset ? fieldset.getAttribute('data-section') : null;
  var targetUrl = swatchLink.getAttribute('data-color-url');

  var currentSection = sectionId ? document.getElementById('MainProduct-' + sectionId) : null;
  if (!currentSection || !targetUrl) return;
  e.preventDefault();

  if (swatchLi.classList.contains('active-color') || window._matatProductSwapping) return;
  window._matatProductSwapping = true;

  var sep = targetUrl.indexOf('?') !== -1 ? '&' : '?';
  var fetchUrl = targetUrl + sep + 'section_id=' + sectionId;

  fetch(fetchUrl)
    .then(function (response) { return response.text(); })
    .then(function (responseText) {
      var doc = new DOMParser().parseFromString(responseText, 'text/html');
      var newSection = doc.getElementById('MainProduct-' + sectionId);
      if (!newSection) {
        window._matatProductSwapping = false;
        return;
      }

      // Destroy old gallery swipers before swapping the DOM
      if (window.mainSwiper) { window.mainSwiper.destroy(true, true); window.mainSwiper = null; }
      if (window.thumbSwiper) { window.thumbSwiper.destroy(true, true); window.thumbSwiper = null; }
      if (mobileSwiper) { mobileSwiper.destroy(true, true); mobileSwiper = null; }

      currentSection.replaceWith(newSection);

      try { window.history.pushState({}, '', targetUrl); } catch (err) {}

      // Force upgrade of the custom elements in the swapped-in markup
      // (variant-radios, product-form, product-info, matat-stock, ...).
      try { customElements.upgrade(newSection); } catch (err) {}

      // Re-init the gallery. Color-variant products use slideToSelectedVariant;
      // products without a color variant show all their images.
      var checkedColor = newSection.querySelector(
        '.variation-color-wrapper .color_label input:checked'
      );
      if (checkedColor) {
        var radios = newSection.querySelector('variant-radios, variant-selects');
        if (radios && typeof radios.slideToSelectedVariant === 'function') {
          radios.currentVariant = { option1: checkedColor.value.trim() };
          radios.slideToSelectedVariant();
        }
      } else {
        if (window.initProductGallery) window.initProductGallery();
        initMobileSwiper();
      }

      // The old gallery element went with the replaced section, and PhotoSwipe
      // binds its click handler straight onto that element — so re-bind the
      // lightbox now the new gallery is populated. Without this, clicking a
      // photo after a colour swap just opened the raw image on its own.
      // Listener lives in snippets/product-media-gallery.liquid.
      document.dispatchEvent(new CustomEvent('matat:gallery-rebuilt'));

      initProductTabs();

      // Update sold-out badge and back-in-stock alert after AJAX color swap
      var jsonScript = newSection.querySelector('script[type="application/json"]');
      var selectedOrFirst = null;
      if (jsonScript) {
        try {
          var variants = JSON.parse(jsonScript.textContent);
          if (Array.isArray(variants)) {
            var hiddenId = newSection.querySelector('input.product-variant-id, input[name="id"]');
            selectedOrFirst = (hiddenId ? variants.find(function(v) { return v.id === Number(hiddenId.value); }) : null) || variants.find(function(v) { return v.available; });
          }
        } catch(e) {}
      }

      var newBadge = newSection.querySelector('#matat-out-of-stock-' + sectionId);
      if (newBadge && selectedOrFirst) {
        newBadge.style.display = selectedOrFirst.available ? 'none' : 'inline-block';
      }

      // Update back-in-stock alert after AJAX color swap
      var backStockAlert = newSection.querySelector('.matat-backin-stock-alert');
      var backStockBtn = newSection.querySelector('.matat-stock-notify-submit');
      var addBtn = newSection.querySelector('.product-form__submit');
      if (backStockAlert && addBtn) {
        var isSoldOut = addBtn.hasAttribute('disabled') || addBtn.getAttribute('disabled') === 'disabled';
        if (isSoldOut) {
          backStockAlert.classList.add('active');
          addBtn.classList.add('hidden');
          var outerWrap = addBtn.closest('.product-form-main-container-outer');
          if (outerWrap) outerWrap.classList.add('backinstock-active-main');
          var prodForm = addBtn.closest('product-form');
          if (prodForm) prodForm.classList.add('backinstock-active');
        } else {
          backStockAlert.classList.remove('active');
          addBtn.classList.remove('hidden');
          var outerWrap = addBtn.closest('.product-form-main-container-outer');
          if (outerWrap) outerWrap.classList.remove('backinstock-active-main');
          var prodForm = addBtn.closest('product-form');
          if (prodForm) prodForm.classList.remove('backinstock-active');
        }
        // Update back-in-stock button data attributes for the new product/variant
        if (backStockBtn && selectedOrFirst) {
          backStockBtn.setAttribute('data-id', selectedOrFirst.id);
          backStockBtn.setAttribute('data-variant-id', selectedOrFirst.id);
          backStockBtn.setAttribute('data-variant-title', selectedOrFirst.title);
          if (selectedOrFirst.featured_image) {
            backStockBtn.setAttribute('data-src', selectedOrFirst.featured_image);
          }
        }
      }

      // Re-init back-in-stock event handlers on new DOM elements
      if (typeof window.initBackInStockHandlers === 'function') {
        window.initBackInStockHandlers(newSection);
      }

      // Ease the page back up now the swapped-in section and its
      // gallery are in place, so the new product is visible.
      matatScrollProductTop(newSection);

      window._matatProductSwapping = false;
    })
    .catch(function () {
      window._matatProductSwapping = false;
    });
});


// ============================================================
// MEGA MENU — DESKTOP INTERACTIONS
// Controls: snippets/header-main-menu.liquid
// CSS:      base.css — MEGA MENU DESKTOP section
//
// Responsibilities:
//   1. Hover intent — open panel after 80ms, close immediately on leave
//   2. Sub Menu Item activation — hover or click based on data-submenu-trigger
//   3. Keyboard nav — Escape closes open panel
//   4. Theme editor — re-init on shopify:section:load
//
// Classes toggled:
//   .mega-menu-open     on <li.site-nav__item--has-mega> to show panel
//   .mega-menu__sub-nav-item--active  on sidebar labels (Block 3)
//   .mega-menu__sub-content--active   on content panels (Block 3)
// ============================================================

(function () {

  var HOVER_DELAY = 80; // ms before panel opens — prevents flicker on fast mouse-overs

  // ── Init ──────────────────────────────────────────────────────────────────

  function initMegaMenu() {
    var nav = document.querySelector('.site-nav--mega');
    if (!nav) return;

    var subTrigger = nav.dataset.submenuTrigger || 'hover';
    var navItems   = nav.querySelectorAll('.site-nav__item--has-mega');
    var timers     = {};

    navItems.forEach(function (item, idx) {
      var triggerLink = item.querySelector('.site-nav__link');

      // ── Open / close panel on hover ──────────────────────────────────────
      item.addEventListener('mouseenter', function () {
        timers[idx] = setTimeout(function () {
          closeAllPanels(navItems);
          openPanel(item, triggerLink);
        }, HOVER_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(timers[idx]);
        closePanel(item, triggerLink);
      });

      // ── Keyboard: Enter / Space toggles panel ────────────────────────────
      // Allows keyboard-only users to open/close the mega panel.
      if (triggerLink) {
        triggerLink.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (item.classList.contains('mega-menu-open')) {
              closePanel(item, triggerLink);
            } else {
              closeAllPanels(navItems);
              openPanel(item, triggerLink);
            }
          }
          // Arrow down moves focus into the first link in the panel
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            openPanel(item, triggerLink);
            var firstLink = item.querySelector('.mega-menu__panel a, .mega-menu__panel [role="tab"]');
            if (firstLink) firstLink.focus();
          }
        });
      }

      // ── Sub Menu Item sidebar activation (Block 3) ───────────────────────
      var subNavItems = item.querySelectorAll('.mega-menu__sub-nav-item');
      if (subNavItems.length > 0) {
        var eventType = subTrigger === 'click' ? 'click' : 'mouseenter';
        subNavItems.forEach(function (subItem) {
          subItem.addEventListener(eventType, function () {
            activateSubItem(item, subItem);
          });
          // Keyboard support for sidebar tabs (Arrow keys)
          subItem.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              activateSubItem(item, subItem);
            }
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
              e.preventDefault();
              var next = subItem.nextElementSibling;
              if (next && next.classList.contains('mega-menu__sub-nav-item')) {
                next.focus();
                activateSubItem(item, next);
              }
            }
            if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
              e.preventDefault();
              var prev = subItem.previousElementSibling;
              if (prev && prev.classList.contains('mega-menu__sub-nav-item')) {
                prev.focus();
                activateSubItem(item, prev);
              }
            }
          });
        });
      }

    });

    // ── Close on Escape ───────────────────────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllPanels(navItems);
        // Return focus to the trigger link of whichever panel was open
        var openItem = nav.querySelector('.mega-menu-open .site-nav__link');
        if (openItem) openItem.focus();
      }
    });

    // ── Close when clicking outside nav ──────────────────────────────────────
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAllPanels(navItems);
    });
  }

  // ── Helpers ───────────────────────────────────────────────────────────────

  function openPanel(item, triggerLink) {
    item.classList.add('mega-menu-open');
    if (triggerLink) triggerLink.setAttribute('aria-expanded', 'true');
  }

  function closePanel(item, triggerLink) {
    item.classList.remove('mega-menu-open');
    if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
  }

  function closeAllPanels(navItems) {
    navItems.forEach(function (item) {
      var triggerLink = item.querySelector('.site-nav__link');
      closePanel(item, triggerLink);
    });
  }

  // Activate a Block 3 sidebar item and show its matching content panel
  function activateSubItem(parentItem, subItem) {
    var targetId = subItem.dataset.target;

    parentItem.querySelectorAll('.mega-menu__sub-nav-item').forEach(function (s) {
      s.classList.remove('mega-menu__sub-nav-item--active');
      s.setAttribute('aria-selected', 'false');
      s.setAttribute('tabindex', '-1');
    });

    parentItem.querySelectorAll('.mega-menu__sub-content').forEach(function (c) {
      c.classList.remove('mega-menu__sub-content--active');
      c.setAttribute('aria-hidden', 'true');
    });

    subItem.classList.add('mega-menu__sub-nav-item--active');
    subItem.setAttribute('aria-selected', 'true');
    subItem.setAttribute('tabindex', '0');

    var contentPanel = parentItem.querySelector('.mega-menu__sub-content[data-id="' + targetId + '"]');
    if (contentPanel) {
      contentPanel.classList.add('mega-menu__sub-content--active');
      contentPanel.setAttribute('aria-hidden', 'false');
    }
  }

  // ── Boot & theme editor re-init ───────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', initMegaMenu);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.site-nav--mega')) initMegaMenu();
  });

})();

// ============================================================
// MEGA MENU — DESKTOP END
// ============================================================


// ============================================================
// MEGA MENU — MOBILE INTERACTIONS
// Controls: snippets/header-drawer-matat.liquid
// CSS:      assets/mega-menu.css — sections 8–14
//
// Responsibilities:
//   1. initMobileCardSliders() — init Swiper on .mm-card-slider elements.
//      observer:true re-calculates layout when the hidden drawer opens.
//   2. initMobileAccordion() — smooth expand/collapse for .menu-toggle-button.
//      Uses actual scrollHeight so animation matches content height exactly.
//   3. Re-init on shopify:section:load for theme editor live preview.
// ============================================================

// ============================================================
// MEGA MENU — MOBILE INTERACTIONS
// Controls: snippets/header-drawer-matat.liquid
// CSS:      assets/mega-menu.css — sections 8–14
//
// Responsibilities:
//   1. initMobileCardSliders() — init Swiper on .mm-card-slider elements.
//      observer:true re-calculates layout when the hidden drawer opens.
//   2. initMobileAccordion() — smooth expand/collapse for .menu-toggle-button.
//      Uses actual scrollHeight so animation matches content height exactly.
//   3. Re-init on shopify:section:load for theme editor live preview.
// ============================================================

(function () {

  // ── Accordion Toggle (.menu-toggle-button) ─────────────────────────────────
  // Animates max-height from 0 → scrollHeight (open) and scrollHeight → 0 (close).
  // Double rAF on close ensures the browser paints the starting height before
  // the transition to 0 fires — avoids instant-collapse with no animation.

  function initMobileAccordion() {
    document.querySelectorAll('.menu-toggle-button').forEach(function (btn) {
      if (btn._mmAccordionBound) return;
      btn._mmAccordionBound = true;

      btn.addEventListener('click', function (e) {
        var subMenu = btn.querySelector('.sub-menu');
        if (!subMenu) return;
        if (subMenu.contains(e.target)) return; // ignore clicks on child links

        var isOpen = btn.classList.contains('sub-menu-open');
        if (isOpen) {
          subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              subMenu.style.maxHeight = '0';
            });
          });
          btn.classList.remove('sub-menu-open');
        } else {
          btn.classList.add('sub-menu-open');
          subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
          subMenu.addEventListener('transitionend', function onEnd() {
            subMenu.removeEventListener('transitionend', onEnd);
            if (btn.classList.contains('sub-menu-open')) subMenu.style.maxHeight = 'none';
          });
        }
      });
    });
  }

  function initMobile() {
    initMobileAccordion();
  }

  document.addEventListener('DOMContentLoaded', initMobile);
  document.addEventListener('shopify:section:load', initMobile);

})();

// ============================================================
// MEGA MENU — MOBILE END
// ============================================================